var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstitute(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 731.9 448.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M271.75,95.71C369.23,47.71,469.48-15.04,582.72,10.64c35.11,7.96,67.06,27.87,88.66,56.81,57.75,77.39,53.06,195.92,21.68,283.03-4.09,11.37-9.21,22.39-15.79,32.55-31.85,49.15-85.51,51.47-137.28,37.26-43.8-12.03-82.61-24.4-127.86-12.17-25.06,6.77-49.35,16.08-74.32,23.17-34,9.65-69.05,16.2-104.45,16.86-93.67,1.76-200.67-46.03-208.96-150.63-.54-6.78-.63-13.59-.33-20.39,1.87-41.76,15.67-83.58,53.93-105.26,38.46-21.8,84.09-30.42,125.23-45.88,23.39-8.79,46.09-19.24,68.53-30.29Z",
    fill: "#a8b7f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.75,95.71C369.23,47.71,469.48-15.04,582.72,10.64c35.11,7.96,67.06,27.87,88.66,56.81,57.75,77.39,53.06,195.92,21.68,283.03-4.09,11.37-9.21,22.39-15.79,32.55-31.85,49.15-85.51,51.47-137.28,37.26-43.8-12.03-82.61-24.4-127.86-12.17-25.06,6.77-49.35,16.08-74.32,23.17-34,9.65-69.05,16.2-104.45,16.86-93.67,1.76-200.67-46.03-208.96-150.63-.54-6.78-.63-13.59-.33-20.39,1.87-41.76,15.67-83.58,53.93-105.26,38.46-21.8,84.09-30.42,125.23-45.88,23.39-8.79,46.09-19.24,68.53-30.29Z",
    fill: "#fff",
    opacity: 0.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 254.83,
    y1: 327.59,
    x2: 24.49,
    y2: 433.78,
    fill: "none",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 463.64,
    y1: 327.59,
    x2: 693.97,
    y2: 433.78,
    fill: "none",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M296.15,33.93c-.42-1.68-1.53-4.3-4.45-6.43-4.72-3.43-12-1.29-12-1.29,.43-11.14-7.29-25.72-23.15-25.72s-19.72,12.86-19.72,12.86c0,0-6-7.29-15.86-3.43-9.86,3.86-10.29,16.72-10.29,16.72,0,0-6.43-6.86-13.29-4.71-5.68,1.77-7.54,9.42-8.01,12h106.76Z",
    fill: "none",
    opacity: 0.3,
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.22,120.64c-.33-1.31-1.19-3.35-3.47-5.01-3.68-2.67-9.36-1-9.36-1,.33-8.69-5.68-20.05-18.04-20.05s-15.37,10.02-15.37,10.02c0,0-4.68-5.68-12.36-2.67-7.68,3.01-8.02,13.03-8.02,13.03,0,0-5.01-5.35-10.36-3.68-4.43,1.38-5.87,7.35-6.24,9.36h83.22Z",
    fill: "none",
    opacity: 0.3,
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.7,66.08c-.33-1.31-1.19-3.35-3.47-5.01-3.68-2.67-9.36-1-9.36-1,.33-8.69-5.68-20.05-18.04-20.05s-15.37,10.02-15.37,10.02c0,0-4.68-5.68-12.36-2.67-7.68,3.01-8.02,13.03-8.02,13.03,0,0-5.01-5.35-10.36-3.68-4.43,1.38-5.87,7.35-6.24,9.36H111.7Z",
    fill: "none",
    opacity: 0.3,
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.99,82.51c-.64-2.54-2.31-6.49-6.72-9.7-7.11-5.17-18.11-1.94-18.11-1.94,.65-16.81-10.99-38.8-34.92-38.8s-29.75,19.4-29.75,19.4c0,0-9.05-10.99-23.93-5.17-14.87,5.82-15.52,25.22-15.52,25.22,0,0-9.7-10.35-20.05-7.11-8.57,2.68-11.37,14.22-12.08,18.11h161.08Z",
    fill: "none",
    opacity: 0.3,
    stroke: "#000",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 182.82,
    width: 730.9,
    height: 144.78,
    fill: "#a8b7f2",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 271.38,
    width: 730.9,
    height: 56.22,
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 182.82,
    width: 730.9,
    height: 12.04,
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 170.69,
    width: 730.9,
    height: 17.56,
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.78,
    y: 45.66,
    width: 180.33,
    height: 144.78,
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.82,133.31h-33.47v-51.98h33.47c.64,0,1.15-.52,1.15-1.15s-.52-1.15-1.15-1.15h-33.47V44.77c0-.64-.52-1.15-1.15-1.15s-1.15,.52-1.15,1.15v34.25h-33.1V44.77c0-.64-.52-1.15-1.15-1.15s-1.15,.52-1.15,1.15v34.25h-33.1V44.77c0-.64-.52-1.15-1.15-1.15s-1.15,.52-1.15,1.15v34.25h-33.1V44.77c0-.64-.52-1.15-1.15-1.15s-1.15,.52-1.15,1.15v34.25h-35.83c-.64,0-1.15,.52-1.15,1.15s.52,1.15,1.15,1.15h35.83v51.98h-35.83c-.64,0-1.15,.52-1.15,1.15s.52,1.15,1.15,1.15h35.83v42.12c0,.64,.52,1.15,1.15,1.15s1.15-.52,1.15-1.15v-42.12h33.1v42.12c0,.64,.52,1.15,1.15,1.15s1.15-.52,1.15-1.15v-42.12h33.1v42.12c0,.64,.52,1.15,1.15,1.15s1.15-.52,1.15-1.15v-42.12h33.1v42.12c0,.64,.52,1.15,1.15,1.15s1.15-.52,1.15-1.15v-42.12h33.47c.64,0,1.15-.52,1.15-1.15s-.52-1.15-1.15-1.15Zm-139.69,0v-51.98h33.1v51.98h-33.1Zm35.41,0v-51.98h33.1v51.98h-33.1Zm35.41,0v-51.98h33.1v51.98h-33.1Z",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 263.08,
    y: 53.28,
    width: 19.68,
    height: 137.16,
    fill: "#a8b7f2",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.83,
    y: 56.46,
    width: 36.19,
    height: 10.16,
    fill: "#a8b7f2",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 442.15,
    y: 53.28,
    width: 19.68,
    height: 137.16,
    fill: "#a8b7f2",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.89,
    y: 56.46,
    width: 36.19,
    height: 10.16,
    fill: "#a8b7f2",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M473.26,67.89c-74.2-20.3-152.49-20.3-226.69,0-1.79-6.53-3.57-15.13-5.36-21.66,77.71-21.26,159.7-21.26,237.41,0-1.79,6.53-3.57,15.13-5.36,21.66Z",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.78,
    y: 182.82,
    width: 180.33,
    height: 144.78,
    fill: "#d0c1af",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.8,
    y: 235.97,
    width: 104.3,
    height: 91.63,
    fill: "#e5d5c1",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.8,
    y: 184.53,
    width: 104.3,
    height: 48.31,
    fill: "#e5d5c1",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 263.08,
    y: 190.44,
    width: 19.68,
    height: 137.16,
    fill: "#a8b7f2",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.83,
    y: 193.61,
    width: 36.19,
    height: 10.16,
    fill: "#a8b7f2",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 442.15,
    y: 190.44,
    width: 19.68,
    height: 137.16,
    fill: "#a8b7f2",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.89,
    y: 193.61,
    width: 36.19,
    height: 10.16,
    fill: "#a8b7f2",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M473.26,205.04c-74.2-20.3-152.49-20.3-226.69,0-1.79-6.53-3.57-15.13-5.36-21.66,77.71-21.26,159.7-21.26,237.41,0-1.79,6.53-3.57,15.13-5.36,21.66Z",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.26,65.82c-74.2-20.3-152.49-20.3-226.69,0-1.79-6.53-3.57-13.07-5.36-19.6,77.71-21.26,159.7-21.26,237.41,0-1.79,6.53-3.57,13.07-5.36,19.6Z",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.26,202.98c-74.2-20.3-152.49-20.3-226.69,0-1.79-6.53-3.57-13.07-5.36-19.6,77.71-21.26,159.7-21.26,237.41,0-1.79,6.53-3.57,13.07-5.36,19.6Z",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.5,
    y: 245.68,
    width: 21.59,
    height: 76.83,
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.52,
    y: 245.68,
    width: 21.59,
    height: 76.83,
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.54,
    y: 245.68,
    width: 21.59,
    height: 76.83,
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.15,
    y: 286.32,
    width: 101.6,
    height: 3.81,
    fill: "#e5d5c1",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.83,
    y: 309.14,
    width: 31.87,
    height: 18.45,
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.21,
    y: 309.14,
    width: 31.87,
    height: 18.45,
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 135.31,
    y: 215.99,
    width: 75.36,
    height: 71.03,
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.31,
    y: 267.55,
    width: 75.36,
    height: 3.51,
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.32,
    y: 215.99,
    width: 7.34,
    height: 71.03,
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.23,
    y: 215.99,
    width: 75.36,
    height: 71.03,
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.23,
    y: 267.55,
    width: 75.36,
    height: 3.51,
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.24,
    y: 215.99,
    width: 7.34,
    height: 71.03,
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 619.52,
    y: 215.99,
    width: 75.36,
    height: 71.03,
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.52,
    y: 267.55,
    width: 75.36,
    height: 3.51,
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653.53,
    y: 215.99,
    width: 7.34,
    height: 71.03,
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 516.44,
    y: 215.99,
    width: 75.36,
    height: 71.03,
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.44,
    y: 267.55,
    width: 75.36,
    height: 3.51,
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550.45,
    y: 215.99,
    width: 7.34,
    height: 71.03,
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M320.46,186.54c-.51-3.25-1.03-6.5-1.54-9.75,.74-.12,1.49-.23,2.23-.35,.49,3.25,.98,6.51,1.47,9.76-.72,.11-1.44,.22-2.16,.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.73,185.89c-.47-3.26-.93-6.51-1.4-9.77,.55-.08,1.11-.16,1.66-.23,1.98,1.84,3.92,3.71,5.83,5.59l-.75-6.24c.69-.08,1.39-.16,2.08-.24,.37,3.27,.74,6.54,1.1,9.81-.53,.06-1.06,.12-1.59,.18-1.89-1.89-3.82-3.76-5.78-5.62,.28,2.08,.57,4.16,.85,6.24-.67,.09-1.34,.18-2.01,.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.93,184.38c-.77,.07-1.51,.05-2.22-.08-.71-.13-1.31-.33-1.8-.62,.15-.59,.3-1.18,.45-1.77,.47,.26,1,.45,1.59,.57,.59,.12,1.19,.15,1.81,.09,.68-.06,1.15-.21,1.43-.45,.28-.23,.4-.51,.38-.83-.02-.27-.15-.47-.37-.61-.22-.14-.6-.24-1.13-.31-.54-.06-1.09-.12-1.64-.18-1.82-.2-2.82-1.01-2.97-2.46-.07-.62,.05-1.19,.35-1.69,.3-.5,.74-.92,1.34-1.24,.6-.32,1.31-.52,2.13-.6,.71-.06,1.38-.03,2.01,.12,.63,.14,1.17,.38,1.6,.7-.17,.55-.35,1.1-.52,1.64-.84-.54-1.82-.76-2.94-.66-.6,.06-1.06,.21-1.37,.47-.31,.26-.44,.57-.41,.93,.03,.27,.15,.48,.36,.63,.22,.15,.58,.25,1.08,.3,.55,.06,1.1,.12,1.64,.19,1.88,.23,2.87,1.05,2.98,2.42,.05,.61-.08,1.16-.37,1.65-.3,.49-.74,.88-1.32,1.19-.58,.31-1.28,.5-2.1,.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.65,183.61c-.18-2.69-.35-5.37-.53-8.06-1.12,.07-2.24,.15-3.36,.24-.05-.6-.09-1.19-.14-1.79,3-.23,6.01-.42,9.01-.55,.03,.6,.06,1.19,.08,1.79-1.12,.05-2.24,.11-3.36,.17,.16,2.69,.31,5.38,.47,8.06-.72,.04-1.45,.09-2.17,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.3,183.26c-.14-3.29-.28-6.57-.42-9.86,.75-.03,1.5-.06,2.25-.09,.11,3.29,.23,6.58,.34,9.86-.73,.02-1.45,.05-2.18,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.96,183.05c-.05-2.69-.1-5.38-.15-8.08-1.12,.02-2.24,.05-3.37,.08l-.05-1.79c3.01-.09,6.02-.14,9.02-.14,0,.6,0,1.19,0,1.79-1.12,0-2.24,0-3.37,.02,.03,2.69,.06,5.39,.09,8.08-.73,0-1.45,.02-2.18,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.86,183.21c-1.4-.03-2.47-.4-3.2-1.12-.73-.72-1.1-1.79-1.09-3.21l.02-5.74c.75,0,1.5,0,2.25,.02l-.07,5.75c0,.8,.17,1.41,.53,1.82,.36,.41,.89,.62,1.59,.64,1.42,.03,2.15-.76,2.2-2.37,.05-1.92,.1-3.83,.15-5.75,.74,.02,1.48,.04,2.22,.07-.06,1.91-.13,3.82-.2,5.74-.05,1.42-.45,2.47-1.19,3.17-.75,.7-1.82,1.03-3.22,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.56,183.35c.13-2.69,.27-5.38,.4-8.07-1.12-.06-2.24-.1-3.36-.15l.07-1.79c3.01,.11,6.01,.27,9.02,.48-.04,.6-.08,1.19-.12,1.79-1.12-.08-2.24-.15-3.36-.21-.15,2.69-.31,5.38-.46,8.07-.72-.04-1.45-.08-2.18-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.21,183.76l.72-9.84c.75,.05,1.5,.11,2.25,.17-.26,3.28-.53,6.56-.79,9.84-.72-.06-1.45-.11-2.17-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.06,184.69c-.97-.1-1.8-.4-2.49-.89-.69-.49-1.21-1.13-1.55-1.93-.34-.79-.47-1.7-.38-2.72,.09-1.02,.37-1.9,.86-2.62,.48-.72,1.12-1.26,1.91-1.6,.79-.35,1.7-.47,2.71-.36,1.01,.11,1.88,.41,2.59,.91,.71,.5,1.23,1.16,1.55,1.96,.33,.81,.43,1.71,.3,2.72-.12,1.02-.44,1.88-.94,2.59-.5,.71-1.14,1.24-1.92,1.57-.78,.34-1.66,.46-2.64,.35Zm.19-1.84c.83,.09,1.5-.13,2.03-.65,.53-.52,.85-1.28,.97-2.29,.12-1.02-.03-1.84-.43-2.45-.41-.61-1.04-.97-1.89-1.05-.83-.09-1.52,.13-2.05,.65-.53,.52-.84,1.29-.94,2.31-.1,1.01,.06,1.83,.47,2.44,.41,.62,1.02,.97,1.84,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.77,185.32c.42-3.26,.83-6.53,1.25-9.79,.55,.07,1.11,.14,1.66,.22,1.42,2.3,2.8,4.62,4.14,6.94,.31-2.07,.63-4.14,.94-6.22,.69,.1,1.38,.21,2.07,.32-.51,3.25-1.03,6.5-1.54,9.75-.53-.08-1.06-.17-1.59-.25-1.32-2.33-2.68-4.64-4.08-6.95-.28,2.08-.56,4.16-.84,6.24-.67-.09-1.34-.18-2.01-.26Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M121.67,31.38c-53.4,.09-96.67,41.2-96.67,91.92,0,.25,0,.51,0,.76,.24,27.59,23.18,49.75,50.76,49.06,4.28-.11,8.85,.11,13.42,.85,9.14,1.47,16.22,6.84,21.01,13.03,2.65,3.42,6.63,5.59,10.96,5.6,.17,0,.34,0,.51,0s.34,0,.51,0c4.33-.02,8.31-2.18,10.96-5.6,4.8-6.2,11.87-11.56,21.01-13.03,4.57-.74,9.14-.96,13.42-.85,27.58,.69,50.52-21.48,50.76-49.06,0-.25,0-.51,0-.76,0-50.71-43.26-91.83-96.67-91.92Z",
    fill: "#a8b7f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.67,31.38c-53.4,.09-96.67,41.2-96.67,91.92,0,.25,0,.51,0,.76,.24,27.59,23.18,49.75,50.76,49.06,4.28-.11,8.85,.11,13.42,.85,9.14,1.47,16.22,6.84,21.01,13.03,2.65,3.42,6.63,5.59,10.96,5.6,.17,0,.34,0,.51,0s.34,0,.51,0c4.33-.02,8.31-2.18,10.96-5.6,4.8-6.2,11.87-11.56,21.01-13.03,4.57-.74,9.14-.96,13.42-.85,27.58,.69,50.52-21.48,50.76-49.06,0-.25,0-.51,0-.76,0-50.71-43.26-91.83-96.67-91.92Z",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M104.93,112.14s-1.91-5.46-6.01-7.37c-4.1-1.91-6.83-2.46-6.83-2.46,0,0,2.18,11.2,12.83,9.83Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.88,97.62s-.31-5.78-3.72-8.75c-3.4-2.98-5.87-4.26-5.87-4.26,0,0-1.02,11.36,9.59,13.02Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.4,141.86s-3.66-4.48-8.17-4.87c-4.5-.39-7.26,.03-7.26,.03,0,0,5.88,9.77,15.42,4.85Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.75,152.59s-3.66-4.48-8.17-4.87c-4.5-.39-7.26,.03-7.26,.03,0,0,5.88,9.77,15.42,4.85Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.88,140.5s3.66-4.48,8.17-4.87c4.5-.4,7.26,.03,7.26,.03,0,0-5.88,9.77-15.42,4.85Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.88,148.66s3.66-4.48,8.17-4.87c4.5-.4,7.26,.03,7.26,.03,0,0-5.88,9.77-15.42,4.85Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.77,92.71s-.31-5.78-3.72-8.75c-3.4-2.98-5.87-4.26-5.87-4.26,0,0-1.02,11.36,9.59,13.02Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.99,73.42s-.31-5.78-3.72-8.75c-3.4-2.98-5.87-4.26-5.87-4.26,0,0-1.02,11.36,9.59,13.02Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.29,95.98s.31-5.78,3.72-8.75c3.4-2.98,5.87-4.26,5.87-4.26,0,0,1.02,11.36-9.59,13.02Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.76,85.31s.31-5.78,3.72-8.75c3.4-2.98,5.87-4.26,5.87-4.26,0,0,1.02,11.36-9.59,13.02Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.65,88.55s3.34-4.73,2.51-9.17-1.96-6.99-1.96-6.99c0,0-7.85,8.28-.55,16.16Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.36,110.3s.54-5.76-2.38-9.21c-2.92-3.45-5.18-5.08-5.18-5.08,0,0-2.69,11.09,7.56,14.29Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.62,83.99s1.73-5.52-.42-9.5c-2.14-3.98-4.01-6.05-4.01-6.05,0,0-4.93,10.29,4.43,15.55Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.62,62.01s1.73-5.52-.42-9.5c-2.14-3.98-4.01-6.05-4.01-6.05,0,0-4.93,10.29,4.43,15.55Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.99,126.86s1.73-5.52-.42-9.5c-2.14-3.98-4.01-6.05-4.01-6.05,0,0-4.93,10.29,4.43,15.55Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.93,120.37s4.89-3.1,5.82-7.52c.94-4.42,.85-7.21,.85-7.21,0,0-10.41,4.66-6.67,14.73Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.51,83.99s-1.73-5.52,.42-9.5c2.14-3.98,4.01-6.05,4.01-6.05,0,0,4.93,10.29-4.43,15.55Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.7,65.38s-1.73-5.52,.42-9.5c2.14-3.98,4.01-6.05,4.01-6.05,0,0,4.93,10.29-4.43,15.55Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.33,97.87s4.88-3.12,5.79-7.54c.92-4.43,.82-7.21,.82-7.21,0,0-10.39,4.7-6.62,14.75Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.48,112.99s5.6-1.45,7.85-5.38c2.24-3.92,3.02-6.6,3.02-6.6,0,0-11.34,1.25-10.86,11.98Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.73,126.5s5.25,2.42,9.48,.81,6.51-3.2,6.51-3.2c0,0-9.57-6.21-15.99,2.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.11,114.21s5.25,2.42,9.48,.81c4.22-1.61,6.51-3.2,6.51-3.2,0,0-9.57-6.21-15.99,2.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.35,115.36s5.25,2.42,9.48,.81c4.22-1.61,6.51-3.2,6.51-3.2,0,0-9.57-6.21-15.99,2.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.55,122.06s3.53,4.58,8.02,5.11c4.49,.53,7.25,.19,7.25,.19,0,0-5.59-9.94-15.27-5.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.08,106.23s3.53,4.59,8.02,5.11c4.49,.53,7.25,.19,7.25,.19,0,0-5.59-9.94-15.27-5.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.07,103.08s3.53,4.59,8.02,5.11c4.49,.53,7.25,.19,7.25,.19,0,0-5.59-9.94-15.27-5.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "155.11 144.34 133.73 148.97 159.25 117.17 124.4 149.66 124.19 151.91 122.63 117.77 120.17 171.7 85.81 139.67 111.33 171.46 89.94 166.84 116.97 178.5 119.7 181.9 114.95 360.34 130.31 360.34 124.57 160.38 128.08 156 155.11 144.34",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M594.34,94.46c-42.26,.07-76.5,32.61-76.5,72.74,0,.2,0,.4,0,.6,.19,21.83,18.34,39.37,40.17,38.82,3.39-.08,7,.09,10.62,.67,7.23,1.17,12.83,5.41,16.63,10.31,2.1,2.71,5.25,4.42,8.68,4.43,.13,0,.27,0,.4,0s.27,0,.4,0c3.43-.01,6.58-1.72,8.68-4.43,3.8-4.9,9.4-9.15,16.63-10.31,3.62-.58,7.23-.76,10.62-.67,21.82,.54,39.98-16.99,40.17-38.82,0-.2,0-.4,0-.6,0-40.13-34.24-72.67-76.5-72.74Z",
    fill: "#a8b7f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.34,94.46c-42.26,.07-76.5,32.61-76.5,72.74,0,.2,0,.4,0,.6,.19,21.83,18.34,39.37,40.17,38.82,3.39-.08,7,.09,10.62,.67,7.23,1.17,12.83,5.41,16.63,10.31,2.1,2.71,5.25,4.42,8.68,4.43,.13,0,.27,0,.4,0s.27,0,.4,0c3.43-.01,6.58-1.72,8.68-4.43,3.8-4.9,9.4-9.15,16.63-10.31,3.62-.58,7.23-.76,10.62-.67,21.82,.54,39.98-16.99,40.17-38.82,0-.2,0-.4,0-.6,0-40.13-34.24-72.67-76.5-72.74Z",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M581.1,158.37s-1.51-4.32-4.75-5.83c-3.24-1.51-5.4-1.94-5.4-1.94,0,0,1.73,8.86,10.16,7.78Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.01,146.88s-.25-4.57-2.94-6.93c-2.69-2.36-4.65-3.37-4.65-3.37,0,0-.81,8.99,7.59,10.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.03,181.89s-2.9-3.54-6.46-3.86-5.74,.02-5.74,.02c0,0,4.66,7.73,12.21,3.84Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.35,190.38s-2.9-3.54-6.46-3.86c-3.56-.31-5.74,.02-5.74,.02,0,0,4.66,7.73,12.21,3.84Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.44,180.81s2.9-3.54,6.46-3.86c3.56-.31,5.74,.02,5.74,.02,0,0-4.66,7.73-12.21,3.84Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.07,187.27s2.9-3.54,6.46-3.86c3.56-.31,5.74,.02,5.74,.02,0,0-4.66,7.73-12.21,3.84Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.26,142.99s-.25-4.57-2.94-6.93c-2.69-2.36-4.65-3.37-4.65-3.37,0,0-.81,8.99,7.59,10.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.77,127.73s-.25-4.57-2.94-6.93c-2.69-2.36-4.65-3.37-4.65-3.37,0,0-.81,8.99,7.59,10.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.62,145.58s.25-4.57,2.94-6.93c2.69-2.36,4.65-3.37,4.65-3.37,0,0,.81,8.99-7.59,10.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.02,137.13s.25-4.57,2.94-6.93c2.69-2.36,4.65-3.37,4.65-3.37,0,0,.81,8.99-7.59,10.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.53,139.7s2.64-3.74,1.99-7.26c-.65-3.52-1.55-5.53-1.55-5.53,0,0-6.21,6.55-.44,12.79Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.47,156.91s.43-4.56-1.89-7.29c-2.31-2.73-4.1-4.02-4.1-4.02,0,0-2.13,8.77,5.98,11.31Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.59,136.09s1.37-4.37-.33-7.52c-1.7-3.15-3.17-4.79-3.17-4.79,0,0-3.9,8.14,3.5,12.31Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.59,118.69s1.37-4.37-.33-7.52c-1.7-3.15-3.17-4.79-3.17-4.79,0,0-3.9,8.14,3.5,12.31Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.05,170.01s1.37-4.37-.33-7.52c-1.7-3.15-3.17-4.79-3.17-4.79,0,0-3.9,8.14,3.5,12.31Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.29,164.88s3.87-2.45,4.61-5.95c.74-3.5,.67-5.7,.67-5.7,0,0-8.24,3.69-5.28,11.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.75,136.09s-1.37-4.37,.33-7.52c1.7-3.15,3.17-4.79,3.17-4.79,0,0,3.9,8.14-3.5,12.31Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.15,121.36s-1.37-4.37,.33-7.52c1.7-3.15,3.17-4.79,3.17-4.79,0,0,3.9,8.14-3.5,12.31Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.15,147.07s3.86-2.47,4.59-5.97c.73-3.5,.65-5.7,.65-5.7,0,0-8.23,3.72-5.24,11.67Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.55,159.04s4.43-1.15,6.21-4.25c1.78-3.11,2.39-5.22,2.39-5.22,0,0-8.97,.99-8.6,9.48Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.55,169.73s4.16,1.92,7.5,.64c3.34-1.28,5.15-2.53,5.15-2.53,0,0-7.57-4.92-12.65,1.89Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.38,160.01s4.16,1.92,7.5,.64c3.34-1.28,5.15-2.53,5.15-2.53,0,0-7.57-4.92-12.65,1.89Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.77,160.91s4.16,1.92,7.5,.64c3.34-1.28,5.15-2.53,5.15-2.53,0,0-7.57-4.92-12.65,1.89Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.17,166.22s2.79,3.63,6.35,4.05c3.55,.42,5.74,.15,5.74,.15,0,0-4.42-7.87-12.09-4.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.09,153.69s2.79,3.63,6.35,4.05c3.55,.42,5.74,.15,5.74,.15,0,0-4.42-7.87-12.09-4.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.72,151.2s2.79,3.63,6.35,4.05c3.55,.42,5.74,.15,5.74,.15,0,0-4.42-7.87-12.09-4.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "620.8 183.85 603.88 187.51 624.08 162.35 596.5 188.06 596.33 189.84 595.1 162.82 593.15 205.5 565.96 180.15 586.15 205.31 569.23 201.65 590.62 210.88 592.78 213.57 589.02 354.78 601.17 354.78 596.64 196.54 599.41 193.08 620.8 183.85",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M682.3,198.4c-25.39,.04-45.95,19.59-45.95,43.69,0,.12,0,.24,0,.36,.11,13.11,11.02,23.65,24.13,23.32,2.04-.05,4.21,.05,6.38,.4,4.34,.7,7.71,3.25,9.99,6.2,1.26,1.63,3.15,2.66,5.21,2.66,.08,0,.16,0,.24,0s.16,0,.24,0c2.06,0,3.95-1.04,5.21-2.66,2.28-2.95,5.64-5.49,9.99-6.2,2.17-.35,4.34-.45,6.38-.4,13.11,.33,24.02-10.21,24.13-23.32,0-.12,0-.24,0-.36,0-24.11-20.57-43.65-45.95-43.69Z",
    fill: "#a8b7f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.3,198.4c-25.39,.04-45.95,19.59-45.95,43.69,0,.12,0,.24,0,.36,.11,13.11,11.02,23.65,24.13,23.32,2.04-.05,4.21,.05,6.38,.4,4.34,.7,7.71,3.25,9.99,6.2,1.26,1.63,3.15,2.66,5.21,2.66,.08,0,.16,0,.24,0s.16,0,.24,0c2.06,0,3.95-1.04,5.21-2.66,2.28-2.95,5.64-5.49,9.99-6.2,2.17-.35,4.34-.45,6.38-.4,13.11,.33,24.02-10.21,24.13-23.32,0-.12,0-.24,0-.36,0-24.11-20.57-43.65-45.95-43.69Z",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M674.34,236.79s-.91-2.6-2.86-3.51-3.25-1.17-3.25-1.17c0,0,1.04,5.32,6.1,4.67Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.69,229.89s-.15-2.75-1.77-4.16c-1.62-1.42-2.79-2.03-2.79-2.03,0,0-.48,5.4,4.56,6.19Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.33,250.92s-1.74-2.13-3.88-2.32c-2.14-.19-3.45,.01-3.45,.01,0,0,2.8,4.65,7.33,2.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.53,256.02s-1.74-2.13-3.88-2.32c-2.14-.19-3.45,.01-3.45,.01,0,0,2.8,4.65,7.33,2.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.33,250.27s1.74-2.13,3.88-2.32c2.14-.19,3.45,.01,3.45,.01,0,0-2.8,4.65-7.33,2.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.5,254.15s1.74-2.13,3.88-2.32c2.14-.19,3.45,.01,3.45,.01,0,0-2.8,4.65-7.33,2.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.03,227.55s-.15-2.75-1.77-4.16c-1.62-1.41-2.79-2.03-2.79-2.03,0,0-.48,5.4,4.56,6.19Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.53,218.39s-.15-2.75-1.77-4.16c-1.62-1.42-2.79-2.03-2.79-2.03,0,0-.48,5.4,4.56,6.19Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.48,229.11s.15-2.75,1.77-4.16c1.62-1.41,2.79-2.03,2.79-2.03,0,0,.48,5.4-4.56,6.19Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.73,224.03s.15-2.75,1.77-4.16c1.62-1.41,2.79-2.03,2.79-2.03,0,0,.48,5.4-4.56,6.19Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.81,225.58s1.59-2.25,1.2-4.36c-.39-2.11-.93-3.32-.93-3.32,0,0-3.73,3.94-.26,7.68Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.58,235.92s.26-2.74-1.13-4.38-2.46-2.42-2.46-2.42c0,0-1.28,5.27,3.59,6.79Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.04,223.41s.82-2.63-.2-4.52c-1.02-1.89-1.91-2.88-1.91-2.88,0,0-2.35,4.89,2.1,7.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.04,212.96s.82-2.63-.2-4.52c-1.02-1.89-1.91-2.88-1.91-2.88,0,0-2.35,4.89,2.1,7.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.12,243.79s.82-2.63-.2-4.52c-1.02-1.89-1.91-2.88-1.91-2.88,0,0-2.34,4.89,2.1,7.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.27,240.7s2.32-1.47,2.77-3.57,.4-3.43,.4-3.43c0,0-4.95,2.22-3.17,7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.55,223.41s-.82-2.63,.2-4.52,1.91-2.88,1.91-2.88c0,0,2.35,4.89-2.1,7.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.2,214.56s-.82-2.63,.2-4.52,1.91-2.88,1.91-2.88c0,0,2.35,4.89-2.1,7.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.79,230.01s2.32-1.48,2.75-3.59c.44-2.1,.39-3.43,.39-3.43,0,0-4.94,2.23-3.15,7.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.04,237.2s2.66-.69,3.73-2.56c1.07-1.87,1.43-3.14,1.43-3.14,0,0-5.39,.59-5.16,5.69Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.64,243.62s2.5,1.15,4.5,.38c2.01-.77,3.1-1.52,3.1-1.52,0,0-4.55-2.95-7.6,1.14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.14,237.78s2.5,1.15,4.5,.38c2.01-.77,3.1-1.52,3.1-1.52,0,0-4.55-2.95-7.6,1.14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.19,238.32s2.5,1.15,4.5,.38c2.01-.77,3.1-1.52,3.1-1.52,0,0-4.55-2.95-7.6,1.14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.17,241.51s1.68,2.18,3.81,2.43,3.45,.09,3.45,.09c0,0-2.66-4.73-7.26-2.52Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.72,233.98s1.68,2.18,3.81,2.43c2.13,.25,3.45,.09,3.45,.09,0,0-2.66-4.73-7.26-2.52Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.89,232.49s1.68,2.18,3.81,2.43c2.13,.25,3.45,.09,3.45,.09,0,0-2.66-4.73-7.26-2.52Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "698.2 252.1 688.03 254.3 700.16 239.18 683.6 254.63 683.49 255.7 682.75 239.46 681.58 265.1 665.25 249.88 677.38 264.99 667.21 262.79 680.06 268.33 681.36 269.95 679.1 354.78 686.4 354.78 683.68 259.72 685.35 257.64 698.2 252.1",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M68.8,198.4c-25.39,.04-45.95,19.59-45.95,43.69,0,.12,0,.24,0,.36,.11,13.11,11.02,23.65,24.13,23.32,2.04-.05,4.21,.05,6.38,.4,4.35,.7,7.71,3.25,9.99,6.2,1.26,1.63,3.15,2.66,5.21,2.66,.08,0,.16,0,.24,0s.16,0,.24,0c2.06,0,3.95-1.04,5.21-2.66,2.28-2.95,5.64-5.49,9.99-6.2,2.17-.35,4.34-.45,6.38-.4,13.11,.33,24.02-10.21,24.13-23.32,0-.12,0-.24,0-.36,0-24.11-20.57-43.65-45.95-43.69Z",
    fill: "#a8b7f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8,198.4c-25.39,.04-45.95,19.59-45.95,43.69,0,.12,0,.24,0,.36,.11,13.11,11.02,23.65,24.13,23.32,2.04-.05,4.21,.05,6.38,.4,4.35,.7,7.71,3.25,9.99,6.2,1.26,1.63,3.15,2.66,5.21,2.66,.08,0,.16,0,.24,0s.16,0,.24,0c2.06,0,3.95-1.04,5.21-2.66,2.28-2.95,5.64-5.49,9.99-6.2,2.17-.35,4.34-.45,6.38-.4,13.11,.33,24.02-10.21,24.13-23.32,0-.12,0-.24,0-.36,0-24.11-20.57-43.65-45.95-43.69Z",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.85,236.79s-.91-2.6-2.86-3.51-3.25-1.17-3.25-1.17c0,0,1.04,5.32,6.1,4.67Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,229.89s-.15-2.75-1.77-4.16c-1.62-1.42-2.79-2.03-2.79-2.03,0,0-.48,5.4,4.56,6.19Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.84,250.92s-1.74-2.13-3.88-2.32c-2.14-.19-3.45,.01-3.45,.01,0,0,2.8,4.65,7.33,2.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.04,256.02s-1.74-2.13-3.88-2.32c-2.14-.19-3.45,.01-3.45,.01,0,0,2.8,4.65,7.33,2.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.84,250.27s1.74-2.13,3.88-2.32c2.14-.19,3.45,.01,3.45,.01,0,0-2.8,4.65-7.33,2.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,254.15s1.74-2.13,3.88-2.32c2.14-.19,3.45,.01,3.45,.01,0,0-2.8,4.65-7.33,2.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.54,227.55s-.15-2.75-1.77-4.16c-1.62-1.41-2.79-2.03-2.79-2.03,0,0-.48,5.4,4.56,6.19Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.04,218.39s-.15-2.75-1.77-4.16-2.79-2.03-2.79-2.03c0,0-.48,5.4,4.56,6.19Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.98,229.11s.15-2.75,1.77-4.16c1.62-1.41,2.79-2.03,2.79-2.03,0,0,.48,5.4-4.56,6.19Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.24,224.03s.15-2.75,1.77-4.16c1.62-1.41,2.79-2.03,2.79-2.03,0,0,.48,5.4-4.56,6.19Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.32,225.58s1.59-2.25,1.2-4.36-.93-3.32-.93-3.32c0,0-3.73,3.94-.26,7.68Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.08,235.92s.26-2.74-1.13-4.38-2.46-2.42-2.46-2.42c0,0-1.28,5.27,3.59,6.79Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.55,223.41s.82-2.63-.2-4.52c-1.02-1.89-1.91-2.88-1.91-2.88,0,0-2.35,4.89,2.1,7.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.55,212.96s.82-2.63-.2-4.52c-1.02-1.89-1.91-2.88-1.91-2.88,0,0-2.35,4.89,2.1,7.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.63,243.79s.82-2.63-.2-4.52c-1.02-1.89-1.91-2.88-1.91-2.88,0,0-2.35,4.89,2.1,7.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.78,240.7s2.32-1.47,2.77-3.57,.4-3.43,.4-3.43c0,0-4.95,2.22-3.17,7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.06,223.41s-.82-2.63,.2-4.52,1.91-2.88,1.91-2.88c0,0,2.35,4.89-2.1,7.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7,214.56s-.82-2.63,.2-4.52,1.91-2.88,1.91-2.88c0,0,2.35,4.89-2.1,7.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.29,230.01s2.32-1.48,2.75-3.59c.44-2.1,.39-3.43,.39-3.43,0,0-4.94,2.23-3.15,7.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.55,237.2s2.66-.69,3.73-2.56c1.07-1.87,1.43-3.14,1.43-3.14,0,0-5.39,.59-5.16,5.69Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.14,243.62s2.5,1.15,4.5,.38c2.01-.77,3.1-1.52,3.1-1.52,0,0-4.55-2.95-7.6,1.14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.65,237.78s2.5,1.15,4.5,.38c2.01-.77,3.1-1.52,3.1-1.52,0,0-4.55-2.95-7.6,1.14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7,238.32s2.5,1.15,4.5,.38c2.01-.77,3.1-1.52,3.1-1.52,0,0-4.55-2.95-7.6,1.14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.68,241.51s1.68,2.18,3.81,2.43,3.45,.09,3.45,.09c0,0-2.66-4.73-7.26-2.52Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.23,233.98s1.68,2.18,3.81,2.43c2.13,.25,3.45,.09,3.45,.09,0,0-2.66-4.73-7.26-2.52Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.39,232.49s1.68,2.18,3.81,2.43c2.13,.25,3.45,.09,3.45,.09,0,0-2.66-4.73-7.26-2.52Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "84.7 252.1 74.54 254.3 86.67 239.18 70.1 254.63 70 255.7 69.26 239.46 68.09 265.1 51.75 249.88 63.88 264.99 53.72 262.79 66.57 268.33 67.87 269.95 65.61 354.78 72.91 354.78 70.18 259.72 71.85 257.64 84.7 252.1",
    fill: "#3b3447"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M618.18,356.53c-.1-.04-.15-.15-.12-.26,2.85-8.74,10.18-15.48,19.13-17.57,.11-.03,.23,.04,.25,.16,.03,.11-.04,.23-.16,.25-8.81,2.06-16.02,8.69-18.83,17.29-.04,.11-.15,.17-.26,.13h-.01Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M625.2,350.93c-1.98-1.64-5.11,1.08-5.06,1.17-.22,.38-.43,.77-.64,1.16,.43-.4,1.87-.63,3.76-.21,1.89,.35,3.88-.64,1.94-2.13Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.28,346.47c-2-1.53-2.97,1.8-1.67,3.35,1.23,1.56,1.89,2.84,1.86,3.43,.18-.41,.36-.81,.56-1.21-.1-.01,1.09-4.04-.75-5.57Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M627.74,348.09c-1.68-1.94-5.19,.17-5.16,.27-.28,.33-.55,.67-.81,1.02,.49-.31,1.94-.28,3.72,.46,1.79,.67,3.92,.04,2.25-1.75Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.65,342.7c-1.71-1.85-3.21,1.25-2.18,2.99,.95,1.74,1.39,3.1,1.27,3.67,.24-.37,.49-.73,.74-1.08-.1-.02,1.72-3.77,.17-5.58Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M630.7,345.73c-1.33-2.19-5.14-.7-5.12-.61-.33,.28-.65,.57-.97,.86,.53-.22,1.95,.05,3.58,1.09,1.65,.97,3.84,.71,2.51-1.34Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.59,339.57c-1.38-2.11-3.37,.69-2.64,2.58,.65,1.87,.86,3.28,.65,3.82,.29-.32,.6-.63,.91-.93-.09-.04,2.32-3.41,1.09-5.46Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M634.03,343.89c-.95-2.38-4.95-1.55-4.95-1.45-.37,.22-.74,.45-1.1,.69,.56-.13,1.91,.38,3.35,1.67,1.47,1.23,3.68,1.34,2.7-.91Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,337.13c-1.01-2.31-3.45,.12-3.05,2.1,.32,1.96,.3,3.38,0,3.87,.34-.26,.69-.52,1.05-.76-.09-.05,2.86-2.98,1.99-5.21Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M637.64,342.63c-.53-2.51-4.66-2.35-4.67-2.25-.4,.16-.8,.32-1.2,.5,.58-.03,1.82,.69,3.03,2.2,1.24,1.46,3.42,1.93,2.84-.45Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.8,335.45c-.61-2.44-3.45-.45-3.39,1.57-.01,1.98-.28,3.39-.66,3.82,.38-.2,.77-.4,1.17-.58-.08-.07,3.34-2.47,2.88-4.81Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M635.31,339.43c-.06-.03,3.05-2.13,5.08-2.46,1.98-.38,2.74,1.01,2.41,1.83-.32,.83-1.71,1.04-2.88,.97-1.16-.16-4.59-.4-4.6-.34Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.26,339.56h-.02c-.05-.04-.08-.1-.07-.16h0c.01-.05,.02-.08,.07-.1,.5-.48,3.38-2.19,5.12-2.47,.98-.19,1.81,.03,2.29,.61,.34,.42,.45,.97,.27,1.41-.43,1.12-2.42,1.09-3.02,1.06-1.13-.16-4.25-.38-4.55-.35-.03,.01-.07,.01-.1,0Zm6.58-2.37c-.33-.14-.79-.2-1.43-.08-1.6,.26-3.85,1.62-4.68,2.18,.29,.01,.75,.04,1.46,.09,.92,.07,2.12,.17,2.74,.26,1.13,.07,2.45-.13,2.73-.88,.14-.35,.05-.79-.23-1.13-.11-.14-.3-.31-.6-.43Z",
    fill: "#3b3447"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M618.33,356.36c-.1,.05-.22,0-.27-.09-4.46-8.04-4.41-17.99,.15-25.98,.06-.1,.19-.14,.29-.08,.1,.06,.14,.19,.08,.29-4.48,7.86-4.54,17.65-.14,25.57,.06,.1,.02,.23-.08,.29h-.01Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M619,347.4c-2.54,.34-2.69,4.48-2.58,4.51,.13,.42,.27,.84,.42,1.26,0-.59,.81-1.8,2.4-2.89,1.54-1.14,2.17-3.28-.24-2.87Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.71,348.71c-2.48,.42-.71,3.4,1.32,3.5,1.98,.17,3.36,.55,3.78,.97-.18-.41-.35-.82-.5-1.23-.08,.06-2.22-3.55-4.59-3.24Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M618.65,343.61c-2.56-.09-3.4,3.92-3.31,3.96,.05,.43,.12,.86,.19,1.29,.11-.57,1.11-1.61,2.87-2.41,1.71-.86,2.7-2.84,.25-2.84Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.24,343.67c-2.52,0-1.27,3.2,.7,3.64,1.92,.49,3.22,1.09,3.55,1.56-.11-.42-.2-.85-.28-1.28-.08,.05-1.59-3.83-3.97-3.92Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M618.94,339.83c-2.51-.52-4.01,3.28-3.93,3.34-.02,.43-.03,.86-.03,1.3,.2-.54,1.37-1.39,3.23-1.88,1.83-.55,3.13-2.34,.72-2.75Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.62,338.65c-2.48-.42-1.79,2.94,.09,3.69,1.81,.8,2.99,1.6,3.24,2.12-.03-.43-.05-.86-.06-1.3-.09,.04-.92-4.02-3.26-4.51Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M619.85,336.15c-2.39-.93-4.51,2.58-4.43,2.64-.09,.42-.17,.85-.24,1.27,.29-.5,1.58-1.14,3.5-1.32,1.9-.24,3.48-1.78,1.17-2.6Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.84,333.76c-2.38-.83-2.26,2.61-.53,3.66,1.65,1.09,2.68,2.08,2.84,2.63,.04-.43,.09-.86,.15-1.29-.1,.03-.24-4.12-2.46-5.01Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M621.38,332.64c-2.2-1.32-4.89,1.81-4.83,1.89-.16,.4-.31,.81-.45,1.22,.37-.45,1.75-.87,3.67-.72,1.91,.08,3.74-1.19,1.6-2.39Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.87,329.11c-2.2-1.22-2.68,2.22-1.16,3.55,1.44,1.36,2.29,2.51,2.35,3.08,.11-.42,.23-.84,.37-1.25-.1,.02,.47-4.13-1.57-5.38Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M617.46,332.17c-.07,.02,.52-3.68,1.66-5.39,1.07-1.71,2.61-1.32,2.98-.52,.39,.79-.4,1.96-1.25,2.77-.91,.74-3.42,3.09-3.38,3.14Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.51,332.29h-.02c-.06,.02-.12,0-.16-.04h0s-.04-.07-.01-.12c-.01-.69,.7-3.96,1.67-5.43,.53-.84,1.26-1.3,2-1.26,.54,.03,1.02,.33,1.22,.76,.53,1.07-.85,2.52-1.28,2.93-.88,.72-3.17,2.86-3.35,3.09-.01,.03-.04,.06-.07,.07Zm2.75-6.43c-.32,.15-.69,.44-1.03,.99-.9,1.35-1.44,3.92-1.59,4.91,.21-.21,.54-.52,1.06-1.01,.67-.63,1.57-1.44,2.05-1.83,.82-.78,1.57-1.88,1.22-2.6-.16-.34-.55-.58-.99-.6-.18-.01-.43,.01-.72,.14Z",
    fill: "#3b3447"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.06,344.48c-.07-.03-.1-.1-.08-.17,1.86-5.71,6.65-10.11,12.5-11.48,.07-.02,.15,.03,.16,.1,.02,.07-.03,.15-.1,.16-5.75,1.35-10.47,5.68-12.3,11.3-.02,.07-.1,.11-.17,.09h0Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.65,340.82c-1.29-1.07-3.34,.7-3.3,.77-.14,.25-.28,.5-.42,.76,.28-.26,1.22-.41,2.45-.14,1.23,.23,2.54-.42,1.27-1.39Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.79,337.91c-1.3-1-1.94,1.17-1.09,2.19,.8,1.02,1.23,1.85,1.22,2.24,.12-.27,.24-.53,.36-.79-.06,0,.71-2.64-.49-3.64Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.31,338.96c-1.09-1.27-3.39,.11-3.37,.18-.18,.22-.36,.44-.53,.67,.32-.2,1.26-.18,2.43,.3,1.17,.44,2.56,.03,1.47-1.14Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.99,335.45c-1.12-1.21-2.1,.82-1.43,1.95,.62,1.14,.91,2.02,.83,2.39,.16-.24,.32-.47,.49-.7-.06-.02,1.13-2.46,.11-3.64Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53.25,337.42c-.87-1.43-3.36-.46-3.34-.4-.21,.18-.43,.37-.63,.56,.35-.15,1.27,.04,2.34,.71,1.08,.63,2.51,.46,1.64-.88Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.56,333.4c-.9-1.38-2.2,.45-1.73,1.68,.42,1.22,.56,2.14,.42,2.49,.19-.21,.39-.41,.59-.61-.06-.02,1.51-2.23,.71-3.57Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.42,336.22c-.62-1.56-3.24-1.01-3.23-.95-.24,.14-.48,.29-.72,.45,.37-.08,1.25,.25,2.19,1.09,.96,.8,2.4,.87,1.76-.59Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.44,331.8c-.66-1.51-2.25,.08-1.99,1.37,.21,1.28,.2,2.21,0,2.53,.22-.17,.45-.34,.68-.5-.06-.03,1.87-1.95,1.3-3.4Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.78,335.4c-.35-1.64-3.04-1.54-3.05-1.47-.26,.1-.53,.21-.78,.33,.38-.02,1.19,.45,1.98,1.44,.81,.95,2.23,1.26,1.85-.29Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.58,330.71c-.4-1.6-2.25-.3-2.21,1.02,0,1.3-.18,2.21-.43,2.5,.25-.13,.5-.26,.76-.38-.05-.04,2.18-1.61,1.88-3.14Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.26,333.31s1.99-1.39,3.32-1.61c1.29-.25,1.79,.66,1.57,1.2-.21,.54-1.11,.68-1.88,.63-.76-.11-3-.26-3.01-.22Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.22,333.39h-.01s-.05-.06-.04-.1h0s.01-.05,.05-.06c.33-.31,2.21-1.43,3.34-1.61,.64-.12,1.18,.02,1.49,.4,.22,.27,.29,.63,.18,.92-.28,.73-1.58,.71-1.97,.69-.74-.1-2.78-.24-2.97-.23-.02,0-.04,0-.07,0Zm4.3-1.55c-.22-.09-.52-.13-.93-.05-1.04,.17-2.52,1.06-3.06,1.42,.19,0,.49,.03,.95,.06,.6,.04,1.38,.11,1.79,.17,.74,.04,1.6-.08,1.79-.57,.09-.23,.03-.52-.15-.74-.07-.09-.2-.2-.39-.28Z",
    fill: "#3b3447"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.16,344.37c-.06,.03-.14,0-.18-.06-2.92-5.25-2.88-11.75,.1-16.97,.04-.07,.12-.09,.19-.05,.07,.04,.09,.12,.05,.19-2.93,5.13-2.96,11.53-.09,16.7,.04,.07,.01,.15-.05,.19h0Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.6,338.51c-1.66,.22-1.75,2.92-1.69,2.94,.08,.28,.18,.55,.27,.82,0-.39,.53-1.17,1.57-1.89,1.01-.75,1.42-2.14-.16-1.88Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.84,339.37c-1.62,.27-.46,2.22,.86,2.29,1.29,.11,2.2,.36,2.47,.63-.12-.27-.23-.53-.33-.8-.05,.04-1.45-2.32-3-2.12Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.37,336.04c-1.67-.06-2.22,2.56-2.16,2.59,.04,.28,.08,.56,.13,.84,.07-.37,.73-1.05,1.87-1.58,1.12-.56,1.76-1.85,.16-1.86Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.53,336.08c-1.64,0-.83,2.09,.46,2.38,1.26,.32,2.1,.71,2.32,1.02-.07-.28-.13-.56-.19-.84-.05,.03-1.04-2.5-2.59-2.56Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.56,333.57c-1.64-.34-2.62,2.15-2.57,2.18-.01,.28-.02,.56-.02,.85,.13-.35,.89-.91,2.11-1.23,1.2-.36,2.05-1.53,.47-1.8Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.78,332.8c-1.62-.28-1.17,1.92,.06,2.41,1.18,.52,1.95,1.05,2.11,1.39-.02-.28-.03-.56-.04-.85-.06,.03-.6-2.62-2.13-2.95Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46.16,331.16c-1.56-.61-2.94,1.68-2.89,1.73-.06,.28-.11,.55-.16,.83,.19-.33,1.03-.74,2.29-.86,1.24-.16,2.27-1.17,.77-1.7Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.57,329.61c-1.55-.54-1.47,1.71-.35,2.39,1.08,.71,1.75,1.36,1.85,1.72,.03-.28,.06-.56,.1-.84-.06,.02-.16-2.69-1.61-3.27Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.16,328.88c-1.44-.86-3.2,1.18-3.15,1.23-.11,.26-.2,.53-.3,.8,.24-.29,1.14-.57,2.4-.47,1.25,.05,2.44-.78,1.05-1.56Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.91,326.56c-1.44-.8-1.75,1.45-.76,2.32,.94,.89,1.5,1.64,1.54,2.01,.07-.27,.15-.55,.24-.82-.07,.01,.31-2.7-1.02-3.51Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.59,328.56s.34-2.41,1.08-3.52c.7-1.12,1.7-.86,1.95-.34,.26,.52-.26,1.28-.82,1.81-.59,.48-2.23,2.02-2.21,2.05Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.63,328.65h-.01s-.08,0-.1-.03h0s-.02-.05,0-.08c0-.45,.46-2.59,1.09-3.55,.34-.55,.82-.85,1.31-.82,.35,.02,.66,.21,.8,.5,.35,.7-.55,1.64-.84,1.92-.58,.47-2.07,1.87-2.19,2.02,0,.02-.03,.04-.05,.05Zm1.79-4.2c-.21,.1-.45,.29-.67,.65-.59,.88-.94,2.56-1.04,3.21,.14-.14,.35-.34,.69-.66,.44-.41,1.02-.94,1.34-1.2,.53-.51,1.03-1.23,.79-1.7-.11-.22-.36-.38-.64-.39-.12,0-.28,0-.47,.09Z",
    fill: "#3b3447"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M586.33,353c.1-.04,.15-.15,.12-.26-2.85-8.74-10.18-15.48-19.13-17.57-.11-.03-.23,.04-.25,.16-.03,.11,.04,.23,.16,.25,8.81,2.06,16.02,8.69,18.83,17.29,.04,.11,.15,.17,.26,.13h.01Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M579.3,347.39c1.98-1.64,5.11,1.08,5.06,1.17,.22,.38,.43,.77,.64,1.16-.43-.4-1.87-.63-3.76-.21-1.89,.35-3.88-.64-1.94-2.13Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.23,342.94c2-1.53,2.97,1.8,1.67,3.35-1.23,1.56-1.89,2.84-1.86,3.43-.18-.41-.36-.81-.56-1.21,.1-.01-1.09-4.04,.75-5.57Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M576.77,344.55c1.68-1.94,5.19,.17,5.16,.27,.28,.33,.55,.67,.81,1.02-.49-.31-1.94-.28-3.72,.46-1.79,.67-3.92,.04-2.25-1.75Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.86,339.17c1.71-1.85,3.21,1.25,2.18,2.99-.95,1.74-1.39,3.1-1.27,3.67-.24-.37-.49-.73-.74-1.08,.1-.02-1.72-3.77-.17-5.58Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M573.8,342.19c1.33-2.19,5.14-.7,5.12-.61,.33,.28,.65,.57,.97,.86-.53-.22-1.95,.05-3.58,1.09-1.65,.97-3.84,.71-2.51-1.34Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.92,336.03c1.38-2.11,3.37,.69,2.64,2.58-.65,1.87-.86,3.28-.65,3.82-.29-.32-.6-.63-.91-.93,.09-.04-2.32-3.41-1.09-5.46Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M570.48,340.36c.95-2.38,4.95-1.55,4.95-1.45,.37,.22,.74,.45,1.1,.69-.56-.13-1.91,.38-3.35,1.67-1.47,1.23-3.68,1.34-2.7-.91Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.51,333.59c1.01-2.31,3.45,.12,3.05,2.1-.32,1.96-.3,3.38,0,3.87-.34-.26-.69-.52-1.05-.76,.09-.05-2.86-2.98-1.99-5.21Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M566.87,339.1c.53-2.51,4.66-2.35,4.67-2.25,.4,.16,.8,.32,1.2,.5-.58-.03-1.82,.69-3.03,2.2-1.24,1.46-3.42,1.93-2.84-.45Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.71,331.92c.61-2.44,3.45-.45,3.39,1.57,.01,1.98,.28,3.39,.66,3.82-.38-.2-.77-.4-1.17-.58,.08-.07-3.34-2.47-2.88-4.81Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M569.2,335.89c.06-.03-3.05-2.13-5.08-2.46-1.98-.38-2.74,1.01-2.41,1.83,.32,.83,1.71,1.04,2.88,.97,1.16-.16,4.59-.4,4.6-.34Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.25,336.02h.02c.05-.04,.08-.1,.07-.16h0c-.01-.05-.02-.08-.07-.1-.5-.48-3.38-2.19-5.12-2.47-.98-.19-1.81,.03-2.29,.61-.34,.42-.45,.97-.27,1.41,.43,1.12,2.42,1.09,3.02,1.06,1.13-.16,4.25-.38,4.55-.35,.03,.01,.07,.01,.1,0Zm-6.58-2.37c.33-.14,.79-.2,1.43-.08,1.6,.26,3.85,1.62,4.68,2.18-.29,.01-.75,.04-1.46,.09-.92,.07-2.12,.17-2.74,.26-1.13,.07-2.45-.13-2.73-.88-.14-.35-.05-.79,.23-1.13,.11-.14,.3-.31,.6-.43Z",
    fill: "#3b3447"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M586.18,352.83c.1,.05,.22,0,.27-.09,4.46-8.04,4.41-17.99-.15-25.98-.06-.1-.19-.14-.29-.08-.1,.06-.14,.19-.08,.29,4.48,7.86,4.54,17.65,.14,25.57-.06,.1-.02,.23,.08,.29h.01Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M585.51,343.86c2.54,.34,2.69,4.48,2.58,4.51-.13,.42-.27,.84-.42,1.26,0-.59-.81-1.8-2.4-2.89-1.54-1.14-2.17-3.28,.24-2.87Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.8,345.17c2.48,.42,.71,3.4-1.32,3.5-1.98,.17-3.36,.55-3.78,.97,.18-.41,.35-.82,.5-1.23,.08,.06,2.22-3.55,4.59-3.24Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M585.86,340.08c2.56-.09,3.4,3.92,3.31,3.96-.05,.43-.12,.86-.19,1.29-.11-.57-1.11-1.61-2.87-2.41-1.71-.86-2.7-2.84-.25-2.84Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.27,340.14c2.52,0,1.27,3.2-.7,3.64-1.92,.49-3.22,1.09-3.55,1.56,.11-.42,.2-.85,.28-1.28,.08,.05,1.59-3.83,3.97-3.92Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M585.57,336.3c2.51-.52,4.01,3.28,3.93,3.34,.02,.43,.03,.86,.03,1.3-.2-.54-1.37-1.39-3.23-1.88-1.83-.55-3.13-2.34-.72-2.75Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.89,335.12c2.48-.42,1.79,2.94-.09,3.69-1.81,.8-2.99,1.6-3.24,2.12,.03-.43,.05-.86,.06-1.3,.09,.04,.92-4.02,3.26-4.51Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M584.66,332.61c2.39-.93,4.51,2.58,4.43,2.64,.09,.42,.17,.85,.24,1.27-.29-.5-1.58-1.14-3.5-1.32-1.9-.24-3.48-1.78-1.17-2.6Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.67,330.23c2.38-.83,2.26,2.61,.53,3.66-1.65,1.09-2.68,2.08-2.84,2.63-.04-.43-.09-.86-.15-1.29,.1,.03,.24-4.12,2.46-5.01Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M583.12,329.11c2.2-1.32,4.89,1.81,4.83,1.89,.16,.4,.31,.81,.45,1.22-.37-.45-1.75-.87-3.67-.72-1.91,.08-3.74-1.19-1.6-2.39Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.63,325.57c2.2-1.22,2.68,2.22,1.16,3.55-1.44,1.36-2.29,2.51-2.35,3.08-.11-.42-.23-.84-.37-1.25,.1,.02-.47-4.13,1.57-5.38Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M587.05,328.63c.07,.02-.52-3.68-1.66-5.39-1.07-1.71-2.61-1.32-2.98-.52-.39,.79,.4,1.96,1.25,2.77,.91,.74,3.42,3.09,3.38,3.14Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.99,328.76h.02c.06,.02,.12,0,.16-.04h0s.04-.07,.01-.12c.01-.69-.7-3.96-1.67-5.43-.53-.84-1.26-1.3-2-1.26-.54,.03-1.02,.33-1.22,.76-.53,1.07,.85,2.52,1.28,2.93,.88,.72,3.17,2.86,3.35,3.09,.01,.03,.04,.06,.07,.07Zm-2.75-6.44c.32,.15,.69,.44,1.03,.99,.9,1.35,1.44,3.92,1.59,4.91-.21-.21-.54-.52-1.06-1.01-.67-.63-1.57-1.44-2.05-1.83-.82-.78-1.57-1.88-1.22-2.6,.16-.34,.55-.58,.99-.6,.18-.01,.43,.01,.72,.14Z",
    fill: "#3b3447"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M104,359.63c.1-.04,.15-.15,.12-.26-2.85-8.74-10.18-15.48-19.13-17.57-.11-.03-.23,.04-.25,.16-.03,.11,.04,.23,.16,.25,8.81,2.06,16.02,8.69,18.83,17.29,.04,.11,.15,.17,.26,.13h.01Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.98,354.02c1.98-1.64,5.11,1.08,5.06,1.17,.22,.38,.43,.77,.64,1.16-.43-.4-1.87-.63-3.76-.21-1.89,.35-3.88-.64-1.94-2.13Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.9,349.56c2-1.53,2.97,1.8,1.67,3.35-1.23,1.56-1.89,2.84-1.86,3.43-.18-.41-.36-.81-.56-1.21,.1-.01-1.09-4.04,.75-5.57Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M94.44,351.18c1.68-1.94,5.19,.17,5.16,.27,.28,.33,.55,.67,.81,1.02-.49-.31-1.94-.28-3.72,.46-1.79,.67-3.92,.04-2.25-1.75Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.53,345.79c1.71-1.85,3.21,1.25,2.18,2.99-.95,1.74-1.39,3.1-1.27,3.67-.24-.37-.49-.73-.74-1.08,.1-.02-1.72-3.77-.17-5.58Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M91.48,348.82c1.33-2.19,5.14-.7,5.12-.61,.33,.28,.65,.57,.97,.86-.53-.22-1.95,.05-3.58,1.09-1.65,.97-3.84,.71-2.51-1.34Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.59,342.66c1.38-2.11,3.37,.69,2.64,2.58-.65,1.87-.86,3.28-.65,3.82-.29-.32-.6-.63-.91-.93,.09-.04-2.32-3.41-1.09-5.46Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M88.16,346.98c.95-2.38,4.95-1.55,4.95-1.45,.37,.22,.74,.45,1.1,.69-.56-.13-1.91,.38-3.35,1.67-1.47,1.23-3.68,1.34-2.7-.91Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.18,340.22c1.01-2.31,3.45,.12,3.05,2.1-.32,1.96-.3,3.38,0,3.87-.34-.26-.69-.52-1.05-.76,.09-.05-2.86-2.98-1.99-5.21Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M84.54,345.72c.53-2.51,4.66-2.35,4.67-2.25,.4,.16,.8,.32,1.2,.5-.58-.03-1.82,.69-3.03,2.2-1.24,1.46-3.42,1.93-2.84-.45Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.38,338.54c.61-2.44,3.45-.45,3.39,1.57,.01,1.98,.28,3.39,.66,3.82-.38-.2-.77-.4-1.17-.58,.08-.07-3.34-2.47-2.88-4.81Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.87,342.52c.06-.03-3.05-2.13-5.08-2.46-1.98-.38-2.74,1.01-2.41,1.83,.32,.83,1.71,1.04,2.88,.97,1.16-.16,4.59-.4,4.6-.34Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.92,342.65h.02c.05-.04,.08-.1,.07-.16h0c-.01-.05-.02-.08-.07-.1-.5-.48-3.38-2.19-5.12-2.47-.98-.19-1.81,.03-2.29,.61-.34,.42-.45,.97-.27,1.41,.43,1.12,2.42,1.09,3.02,1.06,1.13-.16,4.25-.38,4.55-.35,.03,.01,.07,.01,.1,0Zm-6.58-2.37c.33-.14,.79-.2,1.43-.08,1.6,.26,3.85,1.62,4.68,2.18-.29,.01-.75,.04-1.46,.09-.92,.07-2.12,.17-2.74,.26-1.13,.07-2.45-.13-2.73-.88-.14-.35-.05-.79,.23-1.13,.11-.14,.3-.31,.6-.43Z",
    fill: "#3b3447"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M103.85,359.46c.1,.05,.22,0,.27-.09,4.46-8.04,4.41-17.99-.15-25.98-.06-.1-.19-.14-.29-.08-.1,.06-.14,.19-.08,.29,4.48,7.86,4.54,17.65,.14,25.57-.06,.1-.02,.23,.08,.29h.01Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M103.18,350.49c2.54,.34,2.69,4.48,2.58,4.51-.13,.42-.27,.84-.42,1.26,0-.59-.81-1.8-2.4-2.89-1.54-1.14-2.17-3.28,.24-2.87Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.47,351.8c2.48,.42,.71,3.4-1.32,3.5-1.98,.17-3.36,.55-3.78,.97,.18-.41,.35-.82,.5-1.23,.08,.06,2.22-3.55,4.59-3.24Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M103.53,346.7c2.56-.09,3.4,3.92,3.31,3.96-.05,.43-.12,.86-.19,1.29-.1-.57-1.11-1.61-2.87-2.41-1.71-.86-2.7-2.84-.25-2.84Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.94,346.76c2.52,0,1.27,3.2-.7,3.64-1.92,.49-3.22,1.09-3.55,1.56,.11-.42,.2-.85,.28-1.28,.08,.05,1.59-3.83,3.97-3.92Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M103.25,342.92c2.51-.52,4.01,3.28,3.93,3.34,.02,.43,.03,.86,.03,1.3-.2-.54-1.37-1.39-3.23-1.88-1.83-.55-3.13-2.34-.72-2.75Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.56,341.75c2.48-.42,1.79,2.94-.09,3.69-1.81,.8-2.99,1.6-3.24,2.12,.03-.43,.05-.86,.06-1.3,.09,.04,.92-4.02,3.26-4.51Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M102.33,339.24c2.39-.93,4.51,2.58,4.43,2.64,.09,.42,.17,.85,.24,1.27-.29-.5-1.58-1.14-3.5-1.32-1.9-.24-3.48-1.78-1.17-2.6Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.34,336.85c2.38-.83,2.26,2.61,.53,3.66-1.65,1.09-2.68,2.08-2.84,2.63-.04-.43-.09-.86-.15-1.29,.1,.03,.24-4.12,2.46-5.01Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M100.8,335.74c2.2-1.32,4.89,1.81,4.83,1.89,.16,.4,.31,.81,.45,1.22-.37-.45-1.75-.87-3.67-.72-1.91,.08-3.74-1.19-1.6-2.39Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.31,332.2c2.2-1.22,2.68,2.22,1.16,3.55-1.45,1.36-2.29,2.51-2.35,3.08-.11-.42-.23-.84-.37-1.25,.1,.02-.47-4.13,1.57-5.38Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M104.73,335.26c.07,.02-.52-3.68-1.66-5.39-1.07-1.71-2.61-1.32-2.98-.52-.39,.79,.4,1.96,1.25,2.77,.91,.74,3.42,3.09,3.38,3.14Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.67,335.39h.02c.06,.02,.12,0,.16-.04h0s.04-.07,.01-.12c.01-.69-.7-3.96-1.67-5.43-.53-.84-1.26-1.3-2-1.26-.54,.03-1.02,.33-1.22,.76-.53,1.07,.85,2.52,1.28,2.93,.88,.72,3.17,2.86,3.35,3.09,.01,.03,.04,.06,.07,.07Zm-2.75-6.43c.32,.15,.69,.44,1.03,.99,.9,1.35,1.44,3.92,1.59,4.91-.21-.21-.54-.52-1.06-1.01-.67-.63-1.57-1.44-2.05-1.83-.82-.78-1.57-1.88-1.22-2.6,.16-.34,.55-.58,.99-.6,.18-.01,.43,.01,.72,.14Z",
    fill: "#3b3447"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M708.93,352.02c.07-.03,.1-.1,.08-.17-1.9-5.81-6.77-10.29-12.72-11.68-.07-.02-.15,.03-.17,.1-.02,.08,.03,.15,.1,.17,5.86,1.37,10.65,5.78,12.52,11.5,.02,.07,.1,.11,.18,.09h0Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M704.26,348.29c1.31-1.09,3.39,.72,3.36,.78,.15,.25,.29,.51,.42,.77-.29-.27-1.24-.42-2.5-.14-1.25,.23-2.58-.43-1.29-1.42Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.2,345.33c1.33-1.02,1.98,1.19,1.11,2.23-.81,1.04-1.25,1.89-1.24,2.28-.12-.27-.24-.54-.37-.8,.07,0-.72-2.69,.5-3.7Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M702.58,346.41c1.11-1.29,3.45,.12,3.43,.18,.19,.22,.37,.45,.54,.68-.33-.21-1.29-.19-2.47,.3-1.19,.45-2.6,.03-1.5-1.16Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.96,342.83c1.14-1.23,2.14,.83,1.45,1.99-.63,1.16-.93,2.06-.84,2.44-.16-.24-.32-.48-.49-.72,.06-.02-1.15-2.5-.11-3.71Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M700.61,344.84c.88-1.46,3.41-.47,3.4-.4,.22,.19,.43,.38,.64,.57-.35-.15-1.29,.04-2.38,.72-1.1,.64-2.56,.47-1.67-.89Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.34,340.74c.92-1.4,2.24,.46,1.76,1.71-.43,1.25-.57,2.18-.43,2.54-.2-.21-.4-.42-.6-.62,.06-.02-1.54-2.27-.72-3.63Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M698.4,343.62c.63-1.58,3.29-1.03,3.29-.96,.25,.15,.49,.3,.73,.46-.37-.09-1.27,.25-2.22,1.11-.97,.82-2.44,.89-1.8-.6Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.41,339.12c.67-1.53,2.29,.08,2.02,1.4-.22,1.3-.2,2.25,0,2.57-.23-.17-.46-.34-.7-.51,.06-.03-1.9-1.98-1.33-3.46Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M696,342.78c.36-1.67,3.1-1.56,3.1-1.5,.27,.1,.53,.21,.8,.33-.38-.02-1.21,.46-2.01,1.46-.82,.97-2.27,1.28-1.89-.3Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.22,338.01c.4-1.62,2.29-.3,2.25,1.04,0,1.32,.19,2.25,.44,2.54-.25-.13-.51-.26-.78-.39,.05-.04-2.22-1.64-1.91-3.2Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M697.54,340.65s-2.03-1.41-3.38-1.63c-1.32-.25-1.82,.67-1.6,1.22,.21,.55,1.13,.69,1.92,.64,.77-.11,3.05-.27,3.06-.23Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.58,340.74h.01s.05-.07,.05-.1h0s-.01-.05-.05-.07c-.33-.32-2.25-1.45-3.4-1.64-.65-.13-1.2,.02-1.52,.41-.23,.28-.3,.64-.18,.94,.28,.74,1.61,.73,2.01,.7,.75-.1,2.83-.25,3.02-.23,.02,0,.05,0,.07,0Zm-4.38-1.57c.22-.09,.53-.14,.95-.05,1.06,.17,2.56,1.07,3.11,1.45-.2,0-.5,.03-.97,.06-.61,.04-1.41,.11-1.82,.17-.75,.04-1.63-.09-1.82-.58-.09-.23-.03-.53,.15-.75,.08-.09,.2-.21,.4-.29Z",
    fill: "#3b3447"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M708.83,351.91c.07,.03,.14,0,.18-.06,2.97-5.34,2.93-11.96-.1-17.27-.04-.07-.12-.09-.19-.05-.07,.04-.09,.12-.05,.19,2.98,5.22,3.02,11.74,.1,17-.04,.07-.01,.15,.05,.19h0Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M708.39,345.95c1.69,.22,1.79,2.97,1.72,2.99-.09,.28-.18,.56-.28,.84,0-.39-.54-1.19-1.6-1.92-1.02-.76-1.44-2.18,.16-1.91Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.23,346.82c1.65,.28,.47,2.26-.88,2.33-1.32,.11-2.24,.37-2.51,.64,.12-.27,.23-.54,.34-.82,.05,.04,1.48-2.36,3.05-2.15Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M708.62,343.43c1.7-.06,2.26,2.61,2.2,2.64-.04,.29-.08,.57-.13,.86-.07-.38-.74-1.07-1.91-1.6-1.14-.57-1.79-1.89-.17-1.89Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.55,343.47c1.67,0,.84,2.13-.47,2.42-1.28,.33-2.14,.72-2.36,1.04,.07-.28,.13-.57,.19-.85,.06,.04,1.05-2.54,2.64-2.61Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M708.43,340.92c1.67-.34,2.67,2.18,2.61,2.22,.01,.29,.02,.57,.02,.86-.13-.36-.91-.92-2.15-1.25-1.22-.37-2.08-1.55-.48-1.83Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.29,340.14c1.65-.28,1.19,1.95-.06,2.45-1.21,.53-1.99,1.07-2.15,1.41,.02-.29,.04-.57,.04-.86,.06,.03,.61-2.67,2.17-3Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M707.82,338.47c1.59-.62,3,1.71,2.95,1.76,.06,.28,.11,.56,.16,.84-.19-.33-1.05-.76-2.33-.87-1.26-.16-2.31-1.19-.78-1.73Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.48,336.88c1.58-.55,1.5,1.74,.35,2.43-1.1,.73-1.78,1.38-1.89,1.75-.03-.29-.06-.57-.1-.86,.06,.02,.16-2.74,1.63-3.33Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M706.8,336.14c1.46-.87,3.25,1.21,3.21,1.25,.11,.27,.21,.54,.3,.81-.24-.3-1.16-.58-2.44-.48-1.27,.05-2.49-.79-1.07-1.59Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.13,333.79c1.46-.81,1.78,1.48,.77,2.36-.96,.9-1.52,1.67-1.56,2.05-.07-.28-.16-.56-.24-.83,.07,.01-.31-2.75,1.04-3.58Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M709.41,335.82s-.34-2.45-1.1-3.59c-.71-1.14-1.73-.87-1.98-.35-.26,.53,.27,1.3,.83,1.84,.6,.49,2.27,2.05,2.25,2.09Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.38,335.91h.01s.08,0,.1-.03h0s.02-.05,0-.08c0-.46-.46-2.63-1.11-3.61-.35-.56-.84-.87-1.33-.84-.36,.02-.68,.22-.81,.5-.35,.71,.56,1.67,.85,1.95,.59,.48,2.11,1.9,2.23,2.06,0,.02,.03,.04,.05,.05Zm-1.83-4.28c.22,.1,.46,.29,.69,.66,.6,.9,.96,2.61,1.06,3.26-.14-.14-.36-.35-.71-.67-.45-.42-1.04-.96-1.36-1.22-.54-.52-1.05-1.25-.81-1.73,.11-.23,.36-.38,.65-.4,.12,0,.29,0,.48,.1Z",
    fill: "#3b3447"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M150.95,352.02c-.07-.03-.1-.1-.08-.17,1.9-5.81,6.77-10.29,12.72-11.68,.07-.02,.15,.03,.17,.1,.02,.08-.03,.15-.1,.17-5.86,1.37-10.65,5.78-12.52,11.5-.02,.07-.1,.11-.18,.09h0Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M155.62,348.29c-1.31-1.09-3.4,.72-3.36,.78-.15,.25-.29,.51-.42,.77,.29-.27,1.24-.42,2.5-.14,1.25,.23,2.58-.43,1.29-1.42Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.69,345.33c-1.33-1.02-1.98,1.19-1.11,2.23,.81,1.04,1.25,1.89,1.24,2.28,.12-.27,.24-.54,.37-.8-.07,0,.72-2.69-.5-3.7Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M157.31,346.41c-1.11-1.29-3.45,.12-3.43,.18-.19,.22-.37,.45-.54,.68,.33-.21,1.29-.19,2.47,.3,1.19,.45,2.6,.03,1.5-1.16Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.93,342.83c-1.14-1.23-2.14,.83-1.45,1.99,.63,1.16,.93,2.06,.84,2.44,.16-.24,.32-.48,.49-.72-.06-.02,1.15-2.5,.11-3.71Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M159.28,344.84c-.88-1.46-3.41-.47-3.4-.4-.22,.19-.43,.38-.64,.57,.35-.15,1.3,.04,2.38,.72,1.1,.64,2.56,.47,1.67-.89Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.54,340.74c-.92-1.4-2.24,.46-1.76,1.71,.43,1.25,.57,2.18,.43,2.54,.2-.21,.4-.42,.6-.62-.06-.02,1.54-2.27,.72-3.63Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M161.49,343.62c-.63-1.58-3.29-1.03-3.29-.96-.25,.15-.49,.3-.73,.46,.37-.09,1.27,.25,2.22,1.11,.97,.82,2.44,.89,1.8-.6Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.47,339.12c-.67-1.53-2.29,.08-2.02,1.4,.22,1.3,.2,2.25,0,2.57,.23-.17,.46-.34,.7-.51-.06-.03,1.9-1.98,1.33-3.46Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M163.89,342.78c-.36-1.67-3.1-1.56-3.1-1.5-.27,.1-.53,.21-.8,.33,.38-.02,1.21,.46,2.01,1.46,.82,.97,2.27,1.28,1.89-.3Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.66,338.01c-.4-1.62-2.29-.3-2.25,1.04,0,1.32-.19,2.25-.44,2.54,.25-.13,.51-.26,.78-.39-.05-.04,2.22-1.64,1.91-3.2Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M162.34,340.65s2.03-1.41,3.38-1.63c1.32-.25,1.82,.67,1.6,1.22-.21,.55-1.13,.69-1.92,.64-.77-.11-3.05-.27-3.06-.23Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.31,340.74h-.01s-.05-.07-.05-.1h0s.01-.05,.05-.07c.33-.32,2.25-1.45,3.4-1.64,.65-.13,1.2,.02,1.52,.41,.23,.28,.3,.64,.18,.94-.28,.74-1.61,.73-2.01,.7-.75-.1-2.83-.25-3.02-.23-.02,0-.05,0-.07,0Zm4.38-1.57c-.22-.09-.53-.14-.95-.05-1.06,.17-2.56,1.07-3.11,1.45,.2,0,.5,.03,.97,.06,.61,.04,1.41,.11,1.82,.17,.75,.04,1.63-.09,1.82-.58,.09-.23,.03-.53-.15-.75-.08-.09-.2-.21-.4-.29Z",
    fill: "#3b3447"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M151.05,351.91c-.07,.03-.14,0-.18-.06-2.97-5.34-2.93-11.96,.1-17.27,.04-.07,.12-.09,.19-.05,.07,.04,.09,.12,.05,.19-2.98,5.22-3.02,11.74-.1,17,.04,.07,.01,.15-.05,.19h0Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M151.5,345.95c-1.69,.22-1.79,2.97-1.72,2.99,.09,.28,.18,.56,.28,.84,0-.39,.54-1.19,1.6-1.92,1.02-.76,1.44-2.18-.16-1.91Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.65,346.82c-1.65,.28-.47,2.26,.88,2.33,1.32,.11,2.24,.37,2.51,.64-.12-.27-.23-.54-.34-.82-.05,.04-1.48-2.36-3.05-2.15Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M151.26,343.43c-1.7-.06-2.26,2.61-2.2,2.64,.04,.29,.08,.57,.13,.86,.07-.38,.74-1.07,1.91-1.6,1.14-.57,1.79-1.89,.17-1.89Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.34,343.47c-1.67,0-.84,2.13,.47,2.42,1.28,.33,2.14,.72,2.36,1.04-.07-.28-.13-.57-.19-.85-.06,.04-1.05-2.54-2.64-2.61Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M151.45,340.92c-1.67-.34-2.67,2.18-2.61,2.22-.01,.29-.02,.57-.02,.86,.13-.36,.91-.92,2.15-1.25,1.22-.37,2.08-1.55,.48-1.83Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.59,340.14c-1.65-.28-1.19,1.95,.06,2.45,1.21,.53,1.99,1.07,2.15,1.41-.02-.29-.04-.57-.04-.86-.06,.03-.61-2.67-2.17-3Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M152.06,338.47c-1.59-.62-3,1.71-2.95,1.76-.06,.28-.11,.56-.16,.84,.19-.33,1.05-.76,2.33-.87,1.26-.16,2.31-1.19,.78-1.73Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.4,336.88c-1.58-.55-1.5,1.74-.35,2.43,1.1,.73,1.78,1.38,1.89,1.75,.03-.29,.06-.57,.1-.86-.06,.02-.16-2.74-1.63-3.33Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M153.08,336.14c-1.46-.87-3.25,1.21-3.21,1.25-.11,.27-.21,.54-.3,.81,.24-.3,1.16-.58,2.44-.48,1.27,.05,2.49-.79,1.07-1.59Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.75,333.79c-1.46-.81-1.78,1.48-.77,2.36,.96,.9,1.52,1.67,1.56,2.05,.07-.28,.16-.56,.24-.83-.07,.01,.31-2.75-1.04-3.58Z",
    fill: "#3b3447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M150.47,335.82s.34-2.45,1.1-3.59c.71-1.14,1.73-.87,1.98-.35,.26,.53-.27,1.3-.83,1.84-.6,.49-2.27,2.05-2.25,2.09Z",
    fill: "#3b3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51,335.91h-.01s-.08,0-.1-.03h0s-.02-.05,0-.08c0-.46,.46-2.63,1.11-3.61,.35-.56,.84-.87,1.33-.84,.36,.02,.68,.22,.81,.5,.35,.71-.56,1.67-.85,1.95-.59,.48-2.11,1.9-2.23,2.06,0,.02-.03,.04-.05,.05Zm1.83-4.28c-.22,.1-.46,.29-.69,.66-.6,.9-.96,2.61-1.06,3.26,.14-.14,.36-.35,.71-.67,.45-.42,1.04-.96,1.36-1.22,.54-.52,1.04-1.25,.81-1.73-.11-.23-.36-.38-.65-.4-.12,0-.29,0-.48,.1Z",
    fill: "#3b3447"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M478.4,307.97s-2.67,4.08-3.69,5.88c-1.02,1.8-2.43,12.47-2.12,15.14,.31,2.67,2.51,4.55,6.43,6.2,3.92,1.65,5.26-.94,5.26-.94,0,0,1.73-14.04,1.73-16.47s-2.27-12.47-3.69-13.89-3.92,4.08-3.92,4.08Z",
    fill: "#897f73",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.92,275.13s-7.08,.9-6.48,3.49c.6,2.59,1.4,2.69,1.4,2.99s-3.29,.8-3.19,2.89c.1,2.09,2.19,2.89,2.49,2.99,.3,.1,.8,1.69,1.3,2.59,.5,.9,.8,2.09,.8,2.09,0,0-1.6,1.2-.9,2.39,.7,1.2,2.89,2.49,5.28,2.89,2.39,.4,5.68-.3,7.88-.8,2.19-.5,3.19-1.4,3.69-2.09,.5-.7,.3-1.3,.2-2.19-.1-.9,.2-1.1,1-2.49,.8-1.4,3.39-4.19,1.79-7.18-1.59-2.99-4.98-5.08-4.98-5.08,0,0,.4-1.79-3.69-2.79-4.09-1-6.58,.3-6.58,.3Z",
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.76,346.17l.41,2.74s-12.71-3.51-14.17-3.94c-1.46-.44-4.4-27.18-4.4-27.18l6.59-8.17s5.84,14.46,6.87,17.24,4.14,12.94,4.7,19.32Z",
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M494.99,389.92l2.23,2.04s5.34,1.55,5.53,2.33,.1,1.55,.1,1.55c0,0-8.54,.19-9.41,.1-.87-.1-4.85-.68-6.6-.68s-1.75-1.65-.58-3.59,8.73-1.75,8.73-1.75Z",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.87,395.07c-3.25,0-8.76,0-9.91-.21-1.3-.23-5.67-1-7.46-1.32-.17,1.01,.22,1.7,1.35,1.7,1.75,0,5.72,.58,6.6,.68,.87,.1,9.41-.1,9.41-.1,0,0,.04-.32,.02-.76Z",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M492.18,359.07l-.1,7.18s-3.49,4.37-3.98,5.92c-.48,1.55-1.75,15.23-1.75,15.72s-.68,1.55-.68,2.04,.1,2.81,.1,2.81c0,0,1.55,0,3.78-.78,2.23-.78,5.43-2.04,5.43-2.04,0,0,.1-1.55-.1-1.94s-.78-.78-.58-1.07c.19-.29,5.43-15.81,5.43-15.81l1.26-3.49s-6.11-9.22-8.83-8.54Z",
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.15,338.7s.29,6.79-.39,10.77c-.68,3.98-2.33,11.45-2.33,11.45,0,0,3.3,12.51,4.17,15.04,.87,2.52,2.33,5.43,3.1,8.63,.78,3.2,1.55,5.43,1.75,6.01,.19,.58-1.16,1.36-2.43,1.65-1.26,.29-6.4-6.6-6.4-6.6,0,0-2.43-2.91-3.98-6.01-1.55-3.1-4.37-8.63-4.56-11.06-.19-2.43-.78-3.98-1.16-5.24-.39-1.26-7.57-10.86-9.89-15.04-2.33-4.17-3.1-9.31-3.1-9.31l3.01-6.31s5.92,4.37,11.84,5.24c5.92,.87,9.31-.48,9.31-.48l1.07,1.26Z",
    fill: "#a8b7f2",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.76,349.46c.68-3.98,.39-10.77,.39-10.77l-1.07-1.26s-3.4,1.36-9.31,.48c-5.92-.87-11.84-5.24-11.84-5.24l-3.01,6.31s.78,5.14,3.1,9.31c1.08,1.93,3.19,5.02,5.19,7.9l-2.28-6.45,1.18-2.59,2.8-1.1s4.17-2.13,5.72-1.75c1.55,.39,6.79,16.59,6.79,16.59,0,0,1.65-7.47,2.33-11.45Z",
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.81,391.18s-2.43-2.13-2.72-3.01-.19-3.98-1.65-4.95c-1.46-.97-4.27-2.72-6.11-.68-1.84,2.04-.39,6.21,1.16,8.54,1.55,2.33,5.04,4.66,7.08,4.85,2.04,.19,3.1-1.94,3.1-2.91s-.87-1.84-.87-1.84Z",
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.41,295.65l-5.43,1.73s3.95,15.62,2.14,28.44c-1.81,12.82-1.23,13.89-1.23,13.89,0,0,6.58,3.12,11.67,1.89,5.1-1.23,9.75-1.81,9.75-1.81,0,0-3.03-13.82-4.55-21.41-.69-3.46,1.73-3.67,1.38-6.46-1.23-9.78-3.21-16.03-3.21-16.03,0,0-6.99-1.48-10.52-.25Z",
    fill: "#a8b7f2",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.18,295.07s.41,3.62,2.55,6.08c2.14,2.47,6.08,.41,6.66-1.73,.58-2.14-.09-7.36-.09-7.36,0,0-1.89,3.33-4.11,3.49s-5.01-.49-5.01-.49Z",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.51,280.71s-1.4,1.89-3.49,3.59c-2.09,1.69-3.79,2.29-3.79,2.29,0,0,.1,4.09,.7,6.08,.6,1.99,1.79,3.59,2.99,4.09,1.2,.5,3.09,.4,4.29-.3s2.19-2.59,2.19-2.59l.9-1.79s2.89-1.3,2.89-2.29-.6-2.49-.6-2.49l-1.5,.4s-1.4,.3-2.19-1.1c-.8-1.4-.2-2.99-.4-3.49-.2-.5-1.99-2.39-1.99-2.39Z",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.5,296.4s.58,13.29,1.26,22.41c.68,9.12,.29,19.6,.29,19.6l-1.46,9.9s-3.4-.49-6.89-1.26c-3.49-.78-6.4-3.59-6.4-3.59,0,0,4.56-13.39,4.75-15.72s-2.13-27.36-1.46-28.52c.68-1.16,7.95-3.4,9.89-2.81Z",
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.98,295.53s2.04,9.7,3.88,15.13c1.84,5.43,9.22,20.18,10.87,26.1,1.65,5.92,2.04,9.41,2.04,9.41,0,0-.97-13.78-3.2-20.57-2.23-6.79-2.43-7.86-2.43-7.86l8.54,2.43s-.58-3.1-1.84-4.85c-1.26-1.75-1.75-1.94-2.43-3.59-.68-1.65-3.2-12.13-5.04-13.97-1.84-1.84-3.49-1.36-4.17-1.36s-6.21-.87-6.21-.87Z",
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.19,314.32s1.8,.12,2.48,.06c.68-.06,2.79-1.3,4.21-.12,1.42,1.18,2.48,2.97,2.6,4.77s-.62,3.47-1.61,3.59c-.99,.12-2.66-.19-4.65-1.12-1.98-.93-3.16-1.98-3.59-2.23-.43-.25-1.3-1.49-1.3-1.49,0,0,1.73-1.05,1.86-3.47Z",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.51,312.46s-4.52,.87-4.58,1.24c-.06,.37,1.24,5.02,1.36,5.2,.12,.19,4.15-.68,4.4-1.3,.25-.62-1.18-5.14-1.18-5.14Z",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "506.8 296.28 510.25 312.68 511.51 312.46 509.07 296.36 506.8 296.28",
    fill: "#897f73",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.87,297.23s-3.53,.24-5.18,1.1-1.8,1.26-1.8,1.26l-.24,.71v.55s-3.06,15.45-3.22,16.16c-.16,.71-1.49,3.69-1.33,5.33s3.45,3.29,4.24,3.53c.78,.24,3.22-.55,3.69-.71s1.88-1.26,2.04-1.57c.16-.31-.78-6.04-.78-6.04l2.35-10.04",
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.99,297.38s1.26,2.12,3.69,9.96c2.43,7.84,1.73,12.24,1.73,12.24,0,0-.47,1.8-.94,2.82s-9.21,5.85-9.21,5.85c0,0,1.44,1.68,1.36,1.92-.08,.24,8.16-6.75,8.16-6.75l2.43-4.63s-1.26-12.55-1.49-13.34c-.24-.78-2.35-8.79-2.35-8.79l-3.37,.71Z",
    fill: "#897f73",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.77,317.15s-4.47-.55-5.88-.47c-1.41,.08-1.96,.86-2.67,3.45-.71,2.59,.94,4.31,2.12,4.55,1.18,.24,2.04,0,2.82-.24,.78-.24,4.79-2.59,5.33-2.75,.55-.16,2.04-.16,2.35-.16s2.98-.08,3.53-.39c.55-.31,.55-.78,.55-1.18s-.08-2.04-.08-2.04c0,0,.71-.86,.71-1.49s-.55-.78-.55-.78c0,0-2.67-1.26-3.92-1.02-1.26,.24-3.53,2.51-3.53,2.51h-.78Z",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M437.75,301.94s-5.6,12.05-6.2,13.41c-.59,1.36,.17,9.93,.42,11.04,.25,1.1,3.4,4.24,5.43,5.01,2.04,.76,5.26,.25,5.26,.25l.85-9.42-1.02-24.02-4.75,3.74Z",
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M469.5,308.56l1.25,3.08s1.91,1.91,3.33,5.49c1.41,3.57,6.98,14.3,6.98,14.3,0,0,2.66,1.91,2.99,2.66,.33,.75,.58,3.99,.25,4.57-.33,.58-2.41,.58-2.41,.58l-.83-1.83s-2.08-1.41-2.41-2.08c-.33-.67-.33-3.82-.33-3.82,0,0-5.32-6.32-7.07-8.4s-4.74-5.99-5.32-6.73c-.58-.75-2.49-3.66-2.49-3.66l-.67-3.74,6.73-.42Z",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.89,339.24s1-1.66,1-2.08-.75-1.16-1-1.41-.75-2-.75-2",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M451.11,361.78l-.3,4.37s-1.74,2.99-2.16,5.51c-.42,2.51-3.71,11.95-4.49,14.04-.78,2.1-2.69,4.37-2.45,5.33,.24,.96,2.51,1.86,2.51,1.86,0,0,2.27,.54,2.51,.66,.24,.12,2.81,2.04,5.03,2.33,2.22,.3,3.35-.24,3.23-.78s-2.27-2.1-2.69-2.75c-.42-.66-3.29-4.85-3.47-5.33-.18-.48,3.41-7.69,5.99-11.65s4.13-8.02,4.13-8.02l1.26-6.77-9.1,1.2Z",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.01,395.09c-.12-.54-2.27-2.1-2.69-2.75-.42-.66-3.29-4.85-3.47-5.33,0,0-.84,.12-.96,.72s-.42,1.5-.42,1.5c0,0-2.63-1.08-3.47-1.74-.16-.12-.32-.25-.48-.37-.87,1.63-1.98,3.16-1.79,3.9,.24,.96,2.51,1.86,2.51,1.86,0,0,2.27,.54,2.51,.66,.24,.12,2.81,2.04,5.03,2.33,2.22,.3,3.35-.24,3.23-.78Z",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M450.21,361.97l1.4,3.38s-.82,6.07,1.17,9.92c1.98,3.85,5.37,15.05,5.72,15.87,.35,.82,1.05,4.2,1.63,4.2s2.8-1.17,2.8-1.17c0,0,2.45-.93,4.43-2.22s2.8-3.97,2.1-4.9c-.7-.93-2.22-.12-3.03,.23-.82,.35-3.5-.12-4.08-.23l-.58-.12s-.58-5.25-1.05-7.7c-.47-2.45-.93-8.29-1.28-11.55-.35-3.27-1.05-7.58-1.05-7.58l-8.17,1.87Z",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.41,388.34l.47,.82s-2.68,2.33-3.38,1.98c.35,.82,1.05,4.2,1.63,4.2s2.8-1.17,2.8-1.17c0,0,2.45-.93,4.43-2.22s2.8-3.97,2.1-4.9c-.7-.93-2.22-.12-3.03,.23-.82,.35-3.5-.12-4.08-.23l-.58-.12s-.82,.58-.35,1.4Z",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M440.32,329.35s-.67,5.49,.67,9.31,2.58,7.23,2.58,7.23l4.91,17.63,10.31-1.16s.67,.5,2.16,.33c1.5-.17,1.91-.25,1.91-.25,0,0,.91-4.99,1.58-9.23,.67-4.24,1.08-16.46,.67-19.04-.42-2.58-1.08-7.15-1.08-7.15,0,0-3.16,2.58-10.64,2.08-7.48-.5-12.39-1.66-12.39-1.66l-.67,1.91Z",
    fill: "#a8b7f2",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "460.02 337.41 456.7 341.65 458.78 362.35",
    fill: "none",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.14,332.26s-.5,2.66-1.33,3.49c-.83,.83-1.91,1.5-1.91,1.5",
    fill: "none",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 445.48,
    y1: 342.37,
    x2: 446.22,
    y2: 344.56,
    fill: "none",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.65,
    y1: 334.08,
    x2: 445.11,
    y2: 341.3,
    fill: "none",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "444.89 348.05 453.62 345.39 453.79 346.72 445.39 349.3",
    fill: "none",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.66,360.07c-.56,.25-1.14,.37-1.7,.28",
    fill: "none",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.62,348.63s1.16,6.32,1.16,7.73c0,.75-.72,1.92-1.74,2.8",
    fill: "none",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M452.66,288.32s-11.46,6-11.62,6.38c-.15,.38-.92,30.85-.92,31.15s-.15,3.77,.31,4.23c.46,.46,9.62,2,15.31,1.46,5.69-.54,8.31-2.08,8.62-2.77s.62-3.92,.62-3.92l-.54-14.23s1.46,.15,2.46-.08,4.08-1.38,4.08-1.38c0,0-2.85-9.15-3.31-11.77-.46-2.62-1.31-6.31-2.08-7.08-.77-.77,1.23-.69-4-1.54-5.23-.85-8.92-.46-8.92-.46Z",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.64,291.93s3.9,10.02,4.58,15.87c.68,5.86-6.62,9.76-9,11.55s-1.87,2.04-1.87,2.04l.42,3.48s6.27-3.26,10.61-8.83,3.23-10.02,3.06-11.04c-.17-1.02-5.18-14.09-5.18-14.09l-2.63,1.02Z",
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M445.04,292.47s-4.38,1.15-5.54,2.92c-1.15,1.77-5.54,24.92-5.54,25.85s.62,1.08,1.08,1.31c.46,.23,5.08-1.15,6.85-2.15,1.77-1,9.92-5.85,10.23-6.08s2.08-1,2.38-1.92c.31-.92,.23-1.69,.23-1.92s.15-1.23,.15-1.62-.15-.92-.15-.92c0,0,.54-1.08-.15-1.38s-.85,0-1.62,.15c-.77,.15-3.31,.46-3.31,.46,0,0-.46,0-.62,1.38-.15,1.38,.08,3.08-.08,3.54-.15,.46-6.15,1.77-6.15,1.77l3-11.77",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.58,306.55c-.69-.31-.85,0-1.62,.15-.77,.15-3.31,.46-3.31,.46,0,0-.46,0-.62,1.38-.15,1.38,.08,3.08-.08,3.54-.15,.46-6.15,1.77-6.15,1.77l.8-3.13c-2.57,.81-5.9,.31-7.71-.08-1.07,5.37-1.93,10.19-1.93,10.6,0,.92,.62,1.08,1.08,1.31,.46,.23,5.08-1.15,6.85-2.15,1.77-1,9.92-5.85,10.23-6.08s2.08-1,2.38-1.92c.31-.92,.23-1.69,.23-1.92s.15-1.23,.15-1.62-.15-.92-.15-.92c0,0,.54-1.08-.15-1.38Z",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.81,
    y1: 313.85,
    x2: 436.12,
    y2: 315.78,
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M464.69,301.09c-.08-.56-.19-1.08-.34-1.54",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.43,310.62s.59-4.11,.43-7.71",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M468.5,277.01s.23,3.15,.15,3.92c-.08,.77-.77,1.15-.77,1.92s1.08,2.15,.69,2.69c-.38,.54-1.15,1-1.15,1,0,0-1,2.69-1.38,3.46-.38,.77-1.38,1.08-3,.85-1.62-.23-3.31-.77-3.31-.77,0,0,.31,4.08-1.31,5.77-1.62,1.69-4,1-5.15-1.69-1.15-2.69-1.46-4.85-1.46-4.85l1.62-6s-.69-1.15-.08-5c.62-3.85,5.23-5.31,7.31-5.62s7.15,.46,7.85,4.31Z",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.73,290.09l-1.92-1.31,1.46,4.77s1.08-2.38,.46-3.46Z",
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.5,282.7s1.92,.69,2.15,.23c.23-.46,.08-1.23,.46-1.46,.38-.23,2.08,.23,2.31-.77,.23-1-1.23-3.08-.62-3.31,.62-.23,4.08,.23,4.77,.23s1.23-.23,1.62-2c.38-1.77-1.31-3-1.77-3.15-.46-.15-2.92-2.62-6.62-2.69-3.69-.08-7.62,1.62-8.54,5-.92,3.38,.08,7.31,.46,8,.38,.69,.54,1.92,.62,2.23,.08,.31,.77,.92,1.62,.92s3.54-3.23,3.54-3.23Z",
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.12,283.7s-.23-3.23-1.69-3c-1.46,.23-1.54,1.08-1.23,2.92,.31,1.85,1.85,2.08,2.08,2.08",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M202.56,375.32s20.8,31.45,22.1,32.94c0,0,0,3.35-2.23,5.58s-4.65,4.65-4.09,5.21c.56,.56,4.44-.56,6.14-.74,3.54-.37,6.7-3.72,6.7-3.72,0,0,3.54-5.21,3.72-8,.19-2.79-4.47-3.72-4.47-3.72l-1.3-.56-12.61-30.52-13.96,3.54Z",
    fill: "#d0c1af",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.43,402.87l-.36-.15c-.08,.81-.24,1.71-.57,2.57-.93,2.42-1.68,2.98-1.68,2.98h-3.16s0,3.35-2.23,5.58-4.65,4.65-4.09,5.21c.56,.56,4.44-.56,6.14-.74,3.54-.37,6.7-3.72,6.7-3.72,0,0,3.54-5.21,3.72-8,.19-2.79-4.47-3.72-4.47-3.72Z",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M185.81,371.79l10.98,38.34-6.33,3.54s-6.51,2.79-6.14,3.91c.37,1.12,3.35,.93,6.89,.93s11.73-.74,12.47-.93,1.12-1.12,1.12-2.42-.74-6.51-.74-7.26-4.47-37.41-4.47-37.41l-13.77,1.3Z",
    fill: "#d0c1af",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.79,415.15c0-.58-.15-1.94-.31-3.34l-5.64,.92-2.05-2.61-6.33,3.54s-6.51,2.79-6.14,3.91c.37,1.12,3.35,.93,6.89,.93s11.73-.74,12.47-.93,1.12-1.12,1.12-2.42Z",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.17,283.92s-6.74,2.76-7.62,4.95c-.88,2.19-2.49,14.77-2.49,14.77,0,0-6.58,10.67-4.97,15.21,1.61,4.53,7.16,5.26,8.63,4.82s4.39-2.78,4.39-2.78c0,0,4.82-34.8,4.97-35.38,.15-.58-2.02-1.87-2.91-1.59Z",
    fill: "#a8b7f2",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.64,319.87s1.75,7.6,1.46,11.11c-.29,3.51-4.82,10.09-9.8,11.55-4.97,1.46-10.38,0-10.38,0l1.17-8.63,1.9-21.49,15.64,7.46Z",
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M184.32,331.4s-1.3,8-1.49,20.66c-.19,12.66,.93,21.59,.93,21.59,0,0,6.14,1.68,8.38,2.05s7.45,0,7.45,0l1.86,1.86,17.5-3.16s1.3-2.61,.37-4.28c-.93-1.68-2.05-3.72-2.05-3.72l5.77-32.2s-24.75,1.68-38.71-2.79Z",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "214.95 369.15 216.52 371.79 214.29 373.27",
    fill: "none",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "218.57 342.94 212.43 364.9 214.04 367.62",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.83,
    y1: 348.14,
    x2: 193.07,
    y2: 345.91,
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "199.58 375.69 197.54 371.97 197.16 357.83 194.68 350.59",
    fill: "none",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200.13,277.28s-11.23,4.73-11.97,6.65c-.74,1.92-4.14,25.41-4.14,33.83s-1.77,14.92-.59,16.25c1.18,1.33,16.1,5.47,25.7,4.87,9.6-.59,14.48-2.07,14.77-3.25,.3-1.18,.74-5.02,.74-5.02,0,0,4.43-31.76,3.55-38.7s-2.22-9.01-3.69-9.9c-1.48-.89-13.74-5.47-16.1-5.61-2.36-.15-8.27,.89-8.27,.89Z",
    fill: "#a8b7f2",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.57,280.78s-4.28,11.84-5.15,16.11-.99,7.89-.99,7.89l-3.29,.33,5.02-21.19s2.55-3.26,4.41-3.15Z",
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.5,282c-.65-.39-3.36-1.48-6.4-2.6-1.41,1.64-3.74,5.1-5.1,11.23-2.05,9.21-.29,12.87,.44,17.11s1.9,9.65,4.53,13.45c1.73,2.5,4.98,5.38,7,7.05,.3-2.25,.78-5.9,1.28-10.06-3.93-4.5-9.8-11.39-10.47-13.22-1.02-2.78,1.61-13.89,3.22-16.67,1.61-2.78,5.51-6.29,5.51-6.29Z",
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.86,321.04c-.37,2.72-.6,5.02-.52,6.31",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.47,300.91s-2.01,9.65-3.23,17.53",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.29,281.12s-5.47,6.2-6.65,12.26c-1.18,6.06,1.77,9.16,1.77,9.16l3.99,6.94s1.33,9.16,7.68,11.52c6.35,2.36,10.19-2.36,9.6-6.06-.59-3.69-3.84-9.16-3.84-9.16,0,0-1.77-11.67-3.69-16.84-1.92-5.17-5.87-6.79-8.86-7.83Z",
    fill: "#a8b7f2",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.04,309.33s-11.52-2.22-11.97-.89c-.44,1.33-4.2,3.33-3.61,4.96,.59,1.62,6.12,6.86,10.55,8.78,4.43,1.92,10.64,.44,11.67-3.25,1.03-3.69-.44-6.65-1.48-8.12",
    fill: "#a8b7f2",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.99,310.81s-3.4-4.28-3.69-4.73c-.3-.44,.44-2.95-.89-3.55-1.33-.59-4.28-1.18-5.91-1.33s-2.66,.59-2.66,1.62,1.03,1.18,1.03,1.18c0,0-.74,2.51-.15,4.58,.59,2.07,1.18,2.36,2.07,2.51s3.55,.89,3.55,.89c0,0,2.19,2.4,3.37,2.26,1.18-.15,2.24-.19,3.28-3.44Z",
    fill: "#d0c1af",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.84,303.06s.29,6.58,.58,7.75c.29,1.17,1.02,1.75,1.46,1.9s4.68-.44,5.12-.88c.44-.44,.15-8.77-.44-9.5-.58-.73-5.26-.29-6.73,.73Z",
    fill: "#d0c1af",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.85,307.3s-1.86,.11-5.37,4.17",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.96,308.95s-1.75,3.84-.33,6.25c1.42,2.41,7.38-3.36,7.38-3.36,0,0-3.95,1.57-5.12,.88-1.16-.69-1.93-2.99-1.93-3.76Z",
    fill: "#d0c1af",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M196.44,272.84l1.92,9.6s-.89,14.48-.74,16.84,2.07,0,2.66-.74c.59-.74,8.42-19.06,8.42-19.06l1.48-3.55s-6.5,.59-8.12,0-6.06-4.58-6.06-4.58l.44,1.48Z",
    fill: "#d0c1af",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.34,282.8c-.13,2.24-.85,14.34-.72,16.48,.15,2.36,2.07,0,2.66-.74,.42-.53,4.58-10.12,6.89-15.48-4.12,2.14-7.3,.76-8.83-.26Z",
    fill: "#3b3447",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M197.47,252.46s-4.28,1.18-5.02,3.4c-.74,2.22,2.36,10.49,2.36,10.49,0,0-2.95-.59-2.95,2.22,0,.58,.07,1.12,.18,1.61,.4,1.75,2.06,2.91,3.84,2.73l.56-.06s2.07,2.81,4.87,4.43c2.81,1.62,9.6,.89,11.23-3.4,1.62-4.28,.74-7.68,.44-8.57s-1.18-8.57-2.66-11.82c-1.48-3.25-10.49-1.77-12.85-1.03Z",
    fill: "#d0c1af",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M210.32,253.49c-1.48-3.25-10.49-1.77-12.85-1.03,0,0-4.28,1.18-5.02,3.4-.74,2.22,2.36,10.49,2.36,10.49,0,0,2.07,0,1.77-1.03-.3-1.03-.74-3.25-.74-3.25,0,0,2.66-.15,2.36-1.03-.3-.89-1.33-5.17-1.33-5.17,0,0,7.68-3.55,12.11-2.22,.53,.16,1.05,.28,1.55,.38-.07-.18-.14-.37-.22-.53Z",
    fill: "#6b645a",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.8,266.62l2.02-.28s-1.15-.23-2.02,.28Z",
    fill: "#fff",
    stroke: "#3b3447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitute);
export default __webpack_public_path__ + "static/media/institute.184c89d4077582df79390d94e11266ad.svg";
export { ForwardRef as ReactComponent };